function ce(i) {
  return i !== null && typeof i == 'object' && 'constructor' in i && i.constructor === Object;
}
function de(i, e) {
  i === void 0 && (i = {}),
    e === void 0 && (e = {}),
    Object.keys(e).forEach((t) => {
      typeof i[t] > 'u' ? (i[t] = e[t]) : ce(e[t]) && ce(i[t]) && Object.keys(e[t]).length > 0 && de(i[t], e[t]);
    });
}
const he = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {blur() {}, nodeName: ''},
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {initEvent() {}};
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return [];
      },
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {hash: '', host: '', hostname: '', href: '', origin: '', pathname: '', protocol: '', search: ''},
};
function _() {
  const i = typeof document < 'u' ? document : {};
  return de(i, he), i;
}
const xe = {
  document: he,
  navigator: {userAgent: ''},
  location: {hash: '', host: '', hostname: '', href: '', origin: '', pathname: '', protocol: '', search: ''},
  history: {replaceState() {}, pushState() {}, go() {}, back() {}},
  CustomEvent: function () {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      },
    };
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {};
  },
  requestAnimationFrame(i) {
    return typeof setTimeout > 'u' ? (i(), null) : setTimeout(i, 0);
  },
  cancelAnimationFrame(i) {
    typeof setTimeout > 'u' || clearTimeout(i);
  },
};
function G() {
  const i = typeof window < 'u' ? window : {};
  return de(i, xe), i;
}
function Ee(i) {
  return (
    i === void 0 && (i = ''),
    i
      .trim()
      .split(' ')
      .filter((e) => !!e.trim())
  );
}
function Ce(i) {
  const e = i;
  Object.keys(e).forEach((t) => {
    try {
      e[t] = null;
    } catch {}
    try {
      delete e[t];
    } catch {}
  });
}
function ae(i, e) {
  return e === void 0 && (e = 0), setTimeout(i, e);
}
function U() {
  return Date.now();
}
function Me(i) {
  const e = G();
  let t;
  return (
    e.getComputedStyle && (t = e.getComputedStyle(i, null)),
    !t && i.currentStyle && (t = i.currentStyle),
    t || (t = i.style),
    t
  );
}
function Pe(i, e) {
  e === void 0 && (e = 'x');
  const t = G();
  let s, n, r;
  const o = Me(i);
  return (
    t.WebKitCSSMatrix
      ? ((n = o.transform || o.webkitTransform),
        n.split(',').length > 6 &&
          (n = n
            .split(', ')
            .map((l) => l.replace(',', '.'))
            .join(', ')),
        (r = new t.WebKitCSSMatrix(n === 'none' ? '' : n)))
      : ((r =
          o.MozTransform ||
          o.OTransform ||
          o.MsTransform ||
          o.msTransform ||
          o.transform ||
          o.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,')),
        (s = r.toString().split(','))),
    e === 'x' && (t.WebKitCSSMatrix ? (n = r.m41) : s.length === 16 ? (n = parseFloat(s[12])) : (n = parseFloat(s[4]))),
    e === 'y' && (t.WebKitCSSMatrix ? (n = r.m42) : s.length === 16 ? (n = parseFloat(s[13])) : (n = parseFloat(s[5]))),
    n || 0
  );
}
function j(i) {
  return (
    typeof i == 'object' && i !== null && i.constructor && Object.prototype.toString.call(i).slice(8, -1) === 'Object'
  );
}
function Le(i) {
  return typeof window < 'u' && typeof window.HTMLElement < 'u'
    ? i instanceof HTMLElement
    : i && (i.nodeType === 1 || i.nodeType === 11);
}
function k() {
  const i = Object(arguments.length <= 0 ? void 0 : arguments[0]),
    e = ['__proto__', 'constructor', 'prototype'];
  for (let t = 1; t < arguments.length; t += 1) {
    const s = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    if (s != null && !Le(s)) {
      const n = Object.keys(Object(s)).filter((r) => e.indexOf(r) < 0);
      for (let r = 0, o = n.length; r < o; r += 1) {
        const l = n[r],
          a = Object.getOwnPropertyDescriptor(s, l);
        a !== void 0 &&
          a.enumerable &&
          (j(i[l]) && j(s[l])
            ? s[l].__swiper__
              ? (i[l] = s[l])
              : k(i[l], s[l])
            : !j(i[l]) && j(s[l])
              ? ((i[l] = {}), s[l].__swiper__ ? (i[l] = s[l]) : k(i[l], s[l]))
              : (i[l] = s[l]));
      }
    }
  }
  return i;
}
function Y(i, e, t) {
  i.style.setProperty(e, t);
}
function ge(i) {
  let {swiper: e, targetPosition: t, side: s} = i;
  const n = G(),
    r = -e.translate;
  let o = null,
    l;
  const a = e.params.speed;
  (e.wrapperEl.style.scrollSnapType = 'none'), n.cancelAnimationFrame(e.cssModeFrameID);
  const c = t > r ? 'next' : 'prev',
    f = (h, m) => (c === 'next' && h >= m) || (c === 'prev' && h <= m),
    u = () => {
      (l = new Date().getTime()), o === null && (o = l);
      const h = Math.max(Math.min((l - o) / a, 1), 0),
        m = 0.5 - Math.cos(h * Math.PI) / 2;
      let v = r + m * (t - r);
      if ((f(v, t) && (v = t), e.wrapperEl.scrollTo({[s]: v}), f(v, t))) {
        (e.wrapperEl.style.overflow = 'hidden'),
          (e.wrapperEl.style.scrollSnapType = ''),
          setTimeout(() => {
            (e.wrapperEl.style.overflow = ''), e.wrapperEl.scrollTo({[s]: v});
          }),
          n.cancelAnimationFrame(e.cssModeFrameID);
        return;
      }
      e.cssModeFrameID = n.requestAnimationFrame(u);
    };
  u();
}
function ve(i) {
  return (
    i.querySelector('.swiper-slide-transform') ||
    (i.shadowRoot && i.shadowRoot.querySelector('.swiper-slide-transform')) ||
    i
  );
}
function F(i, e) {
  return e === void 0 && (e = ''), [...i.children].filter((t) => t.matches(e));
}
function K(i) {
  try {
    console.warn(i);
    return;
  } catch {}
}
function J(i, e) {
  e === void 0 && (e = []);
  const t = document.createElement(i);
  return t.classList.add(...(Array.isArray(e) ? e : Ee(e))), t;
}
function Ie(i, e) {
  const t = [];
  for (; i.previousElementSibling; ) {
    const s = i.previousElementSibling;
    e ? s.matches(e) && t.push(s) : t.push(s), (i = s);
  }
  return t;
}
function Oe(i, e) {
  const t = [];
  for (; i.nextElementSibling; ) {
    const s = i.nextElementSibling;
    e ? s.matches(e) && t.push(s) : t.push(s), (i = s);
  }
  return t;
}
function R(i, e) {
  return G().getComputedStyle(i, null).getPropertyValue(e);
}
function Q(i) {
  let e = i,
    t;
  if (e) {
    for (t = 0; (e = e.previousSibling) !== null; ) e.nodeType === 1 && (t += 1);
    return t;
  }
}
function we(i, e) {
  const t = [];
  let s = i.parentElement;
  for (; s; ) e ? s.matches(e) && t.push(s) : t.push(s), (s = s.parentElement);
  return t;
}
function Ae(i, e) {
  function t(s) {
    s.target === i && (e.call(i, s), i.removeEventListener('transitionend', t));
  }
  i.addEventListener('transitionend', t);
}
function le(i, e, t) {
  const s = G();
  return (
    i[e === 'width' ? 'offsetWidth' : 'offsetHeight'] +
    parseFloat(s.getComputedStyle(i, null).getPropertyValue(e === 'width' ? 'margin-right' : 'margin-top')) +
    parseFloat(s.getComputedStyle(i, null).getPropertyValue(e === 'width' ? 'margin-left' : 'margin-bottom'))
  );
}
function N(i) {
  return (Array.isArray(i) ? i : [i]).filter((e) => !!e);
}
let ee;
function ze() {
  const i = G(),
    e = _();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && 'scrollBehavior' in e.documentElement.style,
    touch: !!('ontouchstart' in i || (i.DocumentTouch && e instanceof i.DocumentTouch)),
  };
}
function Se() {
  return ee || (ee = ze()), ee;
}
let te;
function De(i) {
  let {userAgent: e} = i === void 0 ? {} : i;
  const t = Se(),
    s = G(),
    n = s.navigator.platform,
    r = e || s.navigator.userAgent,
    o = {ios: !1, android: !1},
    l = s.screen.width,
    a = s.screen.height,
    c = r.match(/(Android);?[\s\/]+([\d.]+)?/);
  let f = r.match(/(iPad).*OS\s([\d_]+)/);
  const u = r.match(/(iPod)(.*OS\s([\d_]+))?/),
    h = !f && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
    m = n === 'Win32';
  let v = n === 'MacIntel';
  const y = [
    '1024x1366',
    '1366x1024',
    '834x1194',
    '1194x834',
    '834x1112',
    '1112x834',
    '768x1024',
    '1024x768',
    '820x1180',
    '1180x820',
    '810x1080',
    '1080x810',
  ];
  return (
    !f &&
      v &&
      t.touch &&
      y.indexOf(`${l}x${a}`) >= 0 &&
      ((f = r.match(/(Version)\/([\d.]+)/)), f || (f = [0, 1, '13_0_0']), (v = !1)),
    c && !m && ((o.os = 'android'), (o.android = !0)),
    (f || h || u) && ((o.os = 'ios'), (o.ios = !0)),
    o
  );
}
function ye(i) {
  return i === void 0 && (i = {}), te || (te = De(i)), te;
}
let ie;
function ke() {
  const i = G(),
    e = ye();
  let t = !1;
  function s() {
    const l = i.navigator.userAgent.toLowerCase();
    return l.indexOf('safari') >= 0 && l.indexOf('chrome') < 0 && l.indexOf('android') < 0;
  }
  if (s()) {
    const l = String(i.navigator.userAgent);
    if (l.includes('Version/')) {
      const [a, c] = l
        .split('Version/')[1]
        .split(' ')[0]
        .split('.')
        .map((f) => Number(f));
      t = a < 16 || (a === 16 && c < 2);
    }
  }
  const n = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(i.navigator.userAgent),
    r = s(),
    o = r || (n && e.ios);
  return {isSafari: t || r, needPerspectiveFix: t, need3dFix: o, isWebView: n};
}
function Ge() {
  return ie || (ie = ke()), ie;
}
function $e(i) {
  let {swiper: e, on: t, emit: s} = i;
  const n = G();
  let r = null,
    o = null;
  const l = () => {
      !e || e.destroyed || !e.initialized || (s('beforeResize'), s('resize'));
    },
    a = () => {
      !e ||
        e.destroyed ||
        !e.initialized ||
        ((r = new ResizeObserver((u) => {
          o = n.requestAnimationFrame(() => {
            const {width: h, height: m} = e;
            let v = h,
              y = m;
            u.forEach((M) => {
              let {contentBoxSize: d, contentRect: p, target: g} = M;
              (g && g !== e.el) ||
                ((v = p ? p.width : (d[0] || d).inlineSize), (y = p ? p.height : (d[0] || d).blockSize));
            }),
              (v !== h || y !== m) && l();
          });
        })),
        r.observe(e.el));
    },
    c = () => {
      o && n.cancelAnimationFrame(o), r && r.unobserve && e.el && (r.unobserve(e.el), (r = null));
    },
    f = () => {
      !e || e.destroyed || !e.initialized || s('orientationchange');
    };
  t('init', () => {
    if (e.params.resizeObserver && typeof n.ResizeObserver < 'u') {
      a();
      return;
    }
    n.addEventListener('resize', l), n.addEventListener('orientationchange', f);
  }),
    t('destroy', () => {
      c(), n.removeEventListener('resize', l), n.removeEventListener('orientationchange', f);
    });
}
function Ve(i) {
  let {swiper: e, extendParams: t, on: s, emit: n} = i;
  const r = [],
    o = G(),
    l = function (f, u) {
      u === void 0 && (u = {});
      const h = o.MutationObserver || o.WebkitMutationObserver,
        m = new h((v) => {
          if (e.__preventObserver__) return;
          if (v.length === 1) {
            n('observerUpdate', v[0]);
            return;
          }
          const y = function () {
            n('observerUpdate', v[0]);
          };
          o.requestAnimationFrame ? o.requestAnimationFrame(y) : o.setTimeout(y, 0);
        });
      m.observe(f, {
        attributes: typeof u.attributes > 'u' ? !0 : u.attributes,
        childList: typeof u.childList > 'u' ? !0 : u.childList,
        characterData: typeof u.characterData > 'u' ? !0 : u.characterData,
      }),
        r.push(m);
    },
    a = () => {
      if (e.params.observer) {
        if (e.params.observeParents) {
          const f = we(e.hostEl);
          for (let u = 0; u < f.length; u += 1) l(f[u]);
        }
        l(e.hostEl, {childList: e.params.observeSlideChildren}), l(e.wrapperEl, {attributes: !1});
      }
    },
    c = () => {
      r.forEach((f) => {
        f.disconnect();
      }),
        r.splice(0, r.length);
    };
  t({observer: !1, observeParents: !1, observeSlideChildren: !1}), s('init', a), s('destroy', c);
}
var Be = {
  on(i, e, t) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof e != 'function') return s;
    const n = t ? 'unshift' : 'push';
    return (
      i.split(' ').forEach((r) => {
        s.eventsListeners[r] || (s.eventsListeners[r] = []), s.eventsListeners[r][n](e);
      }),
      s
    );
  },
  once(i, e, t) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof e != 'function') return s;
    function n() {
      s.off(i, n), n.__emitterProxy && delete n.__emitterProxy;
      for (var r = arguments.length, o = new Array(r), l = 0; l < r; l++) o[l] = arguments[l];
      e.apply(s, o);
    }
    return (n.__emitterProxy = e), s.on(i, n, t);
  },
  onAny(i, e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof i != 'function') return t;
    const s = e ? 'unshift' : 'push';
    return t.eventsAnyListeners.indexOf(i) < 0 && t.eventsAnyListeners[s](i), t;
  },
  offAny(i) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const t = e.eventsAnyListeners.indexOf(i);
    return t >= 0 && e.eventsAnyListeners.splice(t, 1), e;
  },
  off(i, e) {
    const t = this;
    return (
      !t.eventsListeners ||
        t.destroyed ||
        !t.eventsListeners ||
        i.split(' ').forEach((s) => {
          typeof e > 'u'
            ? (t.eventsListeners[s] = [])
            : t.eventsListeners[s] &&
              t.eventsListeners[s].forEach((n, r) => {
                (n === e || (n.__emitterProxy && n.__emitterProxy === e)) && t.eventsListeners[s].splice(r, 1);
              });
        }),
      t
    );
  },
  emit() {
    const i = this;
    if (!i.eventsListeners || i.destroyed || !i.eventsListeners) return i;
    let e, t, s;
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
    return (
      typeof r[0] == 'string' || Array.isArray(r[0])
        ? ((e = r[0]), (t = r.slice(1, r.length)), (s = i))
        : ((e = r[0].events), (t = r[0].data), (s = r[0].context || i)),
      t.unshift(s),
      (Array.isArray(e) ? e : e.split(' ')).forEach((a) => {
        i.eventsAnyListeners &&
          i.eventsAnyListeners.length &&
          i.eventsAnyListeners.forEach((c) => {
            c.apply(s, [a, ...t]);
          }),
          i.eventsListeners &&
            i.eventsListeners[a] &&
            i.eventsListeners[a].forEach((c) => {
              c.apply(s, t);
            });
      }),
      i
    );
  },
};
function Fe() {
  const i = this;
  let e, t;
  const s = i.el;
  typeof i.params.width < 'u' && i.params.width !== null ? (e = i.params.width) : (e = s.clientWidth),
    typeof i.params.height < 'u' && i.params.height !== null ? (t = i.params.height) : (t = s.clientHeight),
    !((e === 0 && i.isHorizontal()) || (t === 0 && i.isVertical())) &&
      ((e = e - parseInt(R(s, 'padding-left') || 0, 10) - parseInt(R(s, 'padding-right') || 0, 10)),
      (t = t - parseInt(R(s, 'padding-top') || 0, 10) - parseInt(R(s, 'padding-bottom') || 0, 10)),
      Number.isNaN(e) && (e = 0),
      Number.isNaN(t) && (t = 0),
      Object.assign(i, {width: e, height: t, size: i.isHorizontal() ? e : t}));
}
function Ne() {
  const i = this;
  function e(w, E) {
    return parseFloat(w.getPropertyValue(i.getDirectionLabel(E)) || 0);
  }
  const t = i.params,
    {wrapperEl: s, slidesEl: n, size: r, rtlTranslate: o, wrongRTL: l} = i,
    a = i.virtual && t.virtual.enabled,
    c = a ? i.virtual.slides.length : i.slides.length,
    f = F(n, `.${i.params.slideClass}, swiper-slide`),
    u = a ? i.virtual.slides.length : f.length;
  let h = [];
  const m = [],
    v = [];
  let y = t.slidesOffsetBefore;
  typeof y == 'function' && (y = t.slidesOffsetBefore.call(i));
  let M = t.slidesOffsetAfter;
  typeof M == 'function' && (M = t.slidesOffsetAfter.call(i));
  const d = i.snapGrid.length,
    p = i.slidesGrid.length;
  let g = t.spaceBetween,
    S = -y,
    b = 0,
    P = 0;
  if (typeof r > 'u') return;
  typeof g == 'string' && g.indexOf('%') >= 0
    ? (g = (parseFloat(g.replace('%', '')) / 100) * r)
    : typeof g == 'string' && (g = parseFloat(g)),
    (i.virtualSize = -g),
    f.forEach((w) => {
      o ? (w.style.marginLeft = '') : (w.style.marginRight = ''), (w.style.marginBottom = ''), (w.style.marginTop = '');
    }),
    t.centeredSlides &&
      t.cssMode &&
      (Y(s, '--swiper-centered-offset-before', ''), Y(s, '--swiper-centered-offset-after', ''));
  const D = t.grid && t.grid.rows > 1 && i.grid;
  D ? i.grid.initSlides(f) : i.grid && i.grid.unsetSlides();
  let C;
  const O =
    t.slidesPerView === 'auto' &&
    t.breakpoints &&
    Object.keys(t.breakpoints).filter((w) => typeof t.breakpoints[w].slidesPerView < 'u').length > 0;
  for (let w = 0; w < u; w += 1) {
    C = 0;
    let E;
    if ((f[w] && (E = f[w]), D && i.grid.updateSlide(w, E, f), !(f[w] && R(E, 'display') === 'none'))) {
      if (t.slidesPerView === 'auto') {
        O && (f[w].style[i.getDirectionLabel('width')] = '');
        const x = getComputedStyle(E),
          T = E.style.transform,
          L = E.style.webkitTransform;
        if ((T && (E.style.transform = 'none'), L && (E.style.webkitTransform = 'none'), t.roundLengths))
          C = i.isHorizontal() ? le(E, 'width') : le(E, 'height');
        else {
          const A = e(x, 'width'),
            B = e(x, 'padding-left'),
            Z = e(x, 'padding-right'),
            I = e(x, 'margin-left'),
            $ = e(x, 'margin-right'),
            z = x.getPropertyValue('box-sizing');
          if (z && z === 'border-box') C = A + I + $;
          else {
            const {clientWidth: H, offsetWidth: q} = E;
            C = A + B + Z + I + $ + (q - H);
          }
        }
        T && (E.style.transform = T), L && (E.style.webkitTransform = L), t.roundLengths && (C = Math.floor(C));
      } else
        (C = (r - (t.slidesPerView - 1) * g) / t.slidesPerView),
          t.roundLengths && (C = Math.floor(C)),
          f[w] && (f[w].style[i.getDirectionLabel('width')] = `${C}px`);
      f[w] && (f[w].swiperSlideSize = C),
        v.push(C),
        t.centeredSlides
          ? ((S = S + C / 2 + b / 2 + g),
            b === 0 && w !== 0 && (S = S - r / 2 - g),
            w === 0 && (S = S - r / 2 - g),
            Math.abs(S) < 1 / 1e3 && (S = 0),
            t.roundLengths && (S = Math.floor(S)),
            P % t.slidesPerGroup === 0 && h.push(S),
            m.push(S))
          : (t.roundLengths && (S = Math.floor(S)),
            (P - Math.min(i.params.slidesPerGroupSkip, P)) % i.params.slidesPerGroup === 0 && h.push(S),
            m.push(S),
            (S = S + C + g)),
        (i.virtualSize += C + g),
        (b = C),
        (P += 1);
    }
  }
  if (
    ((i.virtualSize = Math.max(i.virtualSize, r) + M),
    o && l && (t.effect === 'slide' || t.effect === 'coverflow') && (s.style.width = `${i.virtualSize + g}px`),
    t.setWrapperSize && (s.style[i.getDirectionLabel('width')] = `${i.virtualSize + g}px`),
    D && i.grid.updateWrapperSize(C, h),
    !t.centeredSlides)
  ) {
    const w = [];
    for (let E = 0; E < h.length; E += 1) {
      let x = h[E];
      t.roundLengths && (x = Math.floor(x)), h[E] <= i.virtualSize - r && w.push(x);
    }
    (h = w), Math.floor(i.virtualSize - r) - Math.floor(h[h.length - 1]) > 1 && h.push(i.virtualSize - r);
  }
  if (a && t.loop) {
    const w = v[0] + g;
    if (t.slidesPerGroup > 1) {
      const E = Math.ceil((i.virtual.slidesBefore + i.virtual.slidesAfter) / t.slidesPerGroup),
        x = w * t.slidesPerGroup;
      for (let T = 0; T < E; T += 1) h.push(h[h.length - 1] + x);
    }
    for (let E = 0; E < i.virtual.slidesBefore + i.virtual.slidesAfter; E += 1)
      t.slidesPerGroup === 1 && h.push(h[h.length - 1] + w), m.push(m[m.length - 1] + w), (i.virtualSize += w);
  }
  if ((h.length === 0 && (h = [0]), g !== 0)) {
    const w = i.isHorizontal() && o ? 'marginLeft' : i.getDirectionLabel('marginRight');
    f.filter((E, x) => (!t.cssMode || t.loop ? !0 : x !== f.length - 1)).forEach((E) => {
      E.style[w] = `${g}px`;
    });
  }
  if (t.centeredSlides && t.centeredSlidesBounds) {
    let w = 0;
    v.forEach((x) => {
      w += x + (g || 0);
    }),
      (w -= g);
    const E = w - r;
    h = h.map((x) => (x <= 0 ? -y : x > E ? E + M : x));
  }
  if (t.centerInsufficientSlides) {
    let w = 0;
    if (
      (v.forEach((E) => {
        w += E + (g || 0);
      }),
      (w -= g),
      w < r)
    ) {
      const E = (r - w) / 2;
      h.forEach((x, T) => {
        h[T] = x - E;
      }),
        m.forEach((x, T) => {
          m[T] = x + E;
        });
    }
  }
  if (
    (Object.assign(i, {slides: f, snapGrid: h, slidesGrid: m, slidesSizesGrid: v}),
    t.centeredSlides && t.cssMode && !t.centeredSlidesBounds)
  ) {
    Y(s, '--swiper-centered-offset-before', `${-h[0]}px`),
      Y(s, '--swiper-centered-offset-after', `${i.size / 2 - v[v.length - 1] / 2}px`);
    const w = -i.snapGrid[0],
      E = -i.slidesGrid[0];
    (i.snapGrid = i.snapGrid.map((x) => x + w)), (i.slidesGrid = i.slidesGrid.map((x) => x + E));
  }
  if (
    (u !== c && i.emit('slidesLengthChange'),
    h.length !== d && (i.params.watchOverflow && i.checkOverflow(), i.emit('snapGridLengthChange')),
    m.length !== p && i.emit('slidesGridLengthChange'),
    t.watchSlidesProgress && i.updateSlidesOffset(),
    i.emit('slidesUpdated'),
    !a && !t.cssMode && (t.effect === 'slide' || t.effect === 'fade'))
  ) {
    const w = `${t.containerModifierClass}backface-hidden`,
      E = i.el.classList.contains(w);
    u <= t.maxBackfaceHiddenSlides ? E || i.el.classList.add(w) : E && i.el.classList.remove(w);
  }
}
function _e(i) {
  const e = this,
    t = [],
    s = e.virtual && e.params.virtual.enabled;
  let n = 0,
    r;
  typeof i == 'number' ? e.setTransition(i) : i === !0 && e.setTransition(e.params.speed);
  const o = (l) => (s ? e.slides[e.getSlideIndexByData(l)] : e.slides[l]);
  if (e.params.slidesPerView !== 'auto' && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((l) => {
        t.push(l);
      });
    else
      for (r = 0; r < Math.ceil(e.params.slidesPerView); r += 1) {
        const l = e.activeIndex + r;
        if (l > e.slides.length && !s) break;
        t.push(o(l));
      }
  else t.push(o(e.activeIndex));
  for (r = 0; r < t.length; r += 1)
    if (typeof t[r] < 'u') {
      const l = t[r].offsetHeight;
      n = l > n ? l : n;
    }
  (n || n === 0) && (e.wrapperEl.style.height = `${n}px`);
}
function Re() {
  const i = this,
    e = i.slides,
    t = i.isElement ? (i.isHorizontal() ? i.wrapperEl.offsetLeft : i.wrapperEl.offsetTop) : 0;
  for (let s = 0; s < e.length; s += 1)
    e[s].swiperSlideOffset = (i.isHorizontal() ? e[s].offsetLeft : e[s].offsetTop) - t - i.cssOverflowAdjustment();
}
function He(i) {
  i === void 0 && (i = (this && this.translate) || 0);
  const e = this,
    t = e.params,
    {slides: s, rtlTranslate: n, snapGrid: r} = e;
  if (s.length === 0) return;
  typeof s[0].swiperSlideOffset > 'u' && e.updateSlidesOffset();
  let o = -i;
  n && (o = i),
    s.forEach((a) => {
      a.classList.remove(t.slideVisibleClass, t.slideFullyVisibleClass);
    }),
    (e.visibleSlidesIndexes = []),
    (e.visibleSlides = []);
  let l = t.spaceBetween;
  typeof l == 'string' && l.indexOf('%') >= 0
    ? (l = (parseFloat(l.replace('%', '')) / 100) * e.size)
    : typeof l == 'string' && (l = parseFloat(l));
  for (let a = 0; a < s.length; a += 1) {
    const c = s[a];
    let f = c.swiperSlideOffset;
    t.cssMode && t.centeredSlides && (f -= s[0].swiperSlideOffset);
    const u = (o + (t.centeredSlides ? e.minTranslate() : 0) - f) / (c.swiperSlideSize + l),
      h = (o - r[0] + (t.centeredSlides ? e.minTranslate() : 0) - f) / (c.swiperSlideSize + l),
      m = -(o - f),
      v = m + e.slidesSizesGrid[a],
      y = m >= 0 && m <= e.size - e.slidesSizesGrid[a];
    ((m >= 0 && m < e.size - 1) || (v > 1 && v <= e.size) || (m <= 0 && v >= e.size)) &&
      (e.visibleSlides.push(c), e.visibleSlidesIndexes.push(a), s[a].classList.add(t.slideVisibleClass)),
      y && s[a].classList.add(t.slideFullyVisibleClass),
      (c.progress = n ? -u : u),
      (c.originalProgress = n ? -h : h);
  }
}
function We(i) {
  const e = this;
  if (typeof i > 'u') {
    const f = e.rtlTranslate ? -1 : 1;
    i = (e && e.translate && e.translate * f) || 0;
  }
  const t = e.params,
    s = e.maxTranslate() - e.minTranslate();
  let {progress: n, isBeginning: r, isEnd: o, progressLoop: l} = e;
  const a = r,
    c = o;
  if (s === 0) (n = 0), (r = !0), (o = !0);
  else {
    n = (i - e.minTranslate()) / s;
    const f = Math.abs(i - e.minTranslate()) < 1,
      u = Math.abs(i - e.maxTranslate()) < 1;
    (r = f || n <= 0), (o = u || n >= 1), f && (n = 0), u && (n = 1);
  }
  if (t.loop) {
    const f = e.getSlideIndexByData(0),
      u = e.getSlideIndexByData(e.slides.length - 1),
      h = e.slidesGrid[f],
      m = e.slidesGrid[u],
      v = e.slidesGrid[e.slidesGrid.length - 1],
      y = Math.abs(i);
    y >= h ? (l = (y - h) / v) : (l = (y + v - m) / v), l > 1 && (l -= 1);
  }
  Object.assign(e, {progress: n, progressLoop: l, isBeginning: r, isEnd: o}),
    (t.watchSlidesProgress || (t.centeredSlides && t.autoHeight)) && e.updateSlidesProgress(i),
    r && !a && e.emit('reachBeginning toEdge'),
    o && !c && e.emit('reachEnd toEdge'),
    ((a && !r) || (c && !o)) && e.emit('fromEdge'),
    e.emit('progress', n);
}
function qe() {
  const i = this,
    {slides: e, params: t, slidesEl: s, activeIndex: n} = i,
    r = i.virtual && t.virtual.enabled,
    o = i.grid && t.grid && t.grid.rows > 1,
    l = (u) => F(s, `.${t.slideClass}${u}, swiper-slide${u}`)[0];
  e.forEach((u) => {
    u.classList.remove(t.slideActiveClass, t.slideNextClass, t.slidePrevClass);
  });
  let a, c, f;
  if (r)
    if (t.loop) {
      let u = n - i.virtual.slidesBefore;
      u < 0 && (u = i.virtual.slides.length + u),
        u >= i.virtual.slides.length && (u -= i.virtual.slides.length),
        (a = l(`[data-swiper-slide-index="${u}"]`));
    } else a = l(`[data-swiper-slide-index="${n}"]`);
  else
    o
      ? ((a = e.filter((u) => u.column === n)[0]),
        (f = e.filter((u) => u.column === n + 1)[0]),
        (c = e.filter((u) => u.column === n - 1)[0]))
      : (a = e[n]);
  a &&
    (a.classList.add(t.slideActiveClass),
    o
      ? (f && f.classList.add(t.slideNextClass), c && c.classList.add(t.slidePrevClass))
      : ((f = Oe(a, `.${t.slideClass}, swiper-slide`)[0]),
        t.loop && !f && (f = e[0]),
        f && f.classList.add(t.slideNextClass),
        (c = Ie(a, `.${t.slideClass}, swiper-slide`)[0]),
        t.loop && !c === 0 && (c = e[e.length - 1]),
        c && c.classList.add(t.slidePrevClass))),
    i.emitSlidesClasses();
}
const X = (i, e) => {
    if (!i || i.destroyed || !i.params) return;
    const t = () => (i.isElement ? 'swiper-slide' : `.${i.params.slideClass}`),
      s = e.closest(t());
    if (s) {
      let n = s.querySelector(`.${i.params.lazyPreloaderClass}`);
      !n &&
        i.isElement &&
        (s.shadowRoot
          ? (n = s.shadowRoot.querySelector(`.${i.params.lazyPreloaderClass}`))
          : requestAnimationFrame(() => {
              s.shadowRoot && ((n = s.shadowRoot.querySelector(`.${i.params.lazyPreloaderClass}`)), n && n.remove());
            })),
        n && n.remove();
    }
  },
  se = (i, e) => {
    if (!i.slides[e]) return;
    const t = i.slides[e].querySelector('[loading="lazy"]');
    t && t.removeAttribute('loading');
  },
  oe = (i) => {
    if (!i || i.destroyed || !i.params) return;
    let e = i.params.lazyPreloadPrevNext;
    const t = i.slides.length;
    if (!t || !e || e < 0) return;
    e = Math.min(e, t);
    const s = i.params.slidesPerView === 'auto' ? i.slidesPerViewDynamic() : Math.ceil(i.params.slidesPerView),
      n = i.activeIndex;
    if (i.params.grid && i.params.grid.rows > 1) {
      const o = n,
        l = [o - e];
      l.push(...Array.from({length: e}).map((a, c) => o + s + c)),
        i.slides.forEach((a, c) => {
          l.includes(a.column) && se(i, c);
        });
      return;
    }
    const r = n + s - 1;
    if (i.params.rewind || i.params.loop)
      for (let o = n - e; o <= r + e; o += 1) {
        const l = ((o % t) + t) % t;
        (l < n || l > r) && se(i, l);
      }
    else for (let o = Math.max(n - e, 0); o <= Math.min(r + e, t - 1); o += 1) o !== n && (o > r || o < n) && se(i, o);
  };
function je(i) {
  const {slidesGrid: e, params: t} = i,
    s = i.rtlTranslate ? i.translate : -i.translate;
  let n;
  for (let r = 0; r < e.length; r += 1)
    typeof e[r + 1] < 'u'
      ? s >= e[r] && s < e[r + 1] - (e[r + 1] - e[r]) / 2
        ? (n = r)
        : s >= e[r] && s < e[r + 1] && (n = r + 1)
      : s >= e[r] && (n = r);
  return t.normalizeSlideIndex && (n < 0 || typeof n > 'u') && (n = 0), n;
}
function Ye(i) {
  const e = this,
    t = e.rtlTranslate ? e.translate : -e.translate,
    {snapGrid: s, params: n, activeIndex: r, realIndex: o, snapIndex: l} = e;
  let a = i,
    c;
  const f = (m) => {
    let v = m - e.virtual.slidesBefore;
    return (
      v < 0 && (v = e.virtual.slides.length + v), v >= e.virtual.slides.length && (v -= e.virtual.slides.length), v
    );
  };
  if ((typeof a > 'u' && (a = je(e)), s.indexOf(t) >= 0)) c = s.indexOf(t);
  else {
    const m = Math.min(n.slidesPerGroupSkip, a);
    c = m + Math.floor((a - m) / n.slidesPerGroup);
  }
  if ((c >= s.length && (c = s.length - 1), a === r && !e.params.loop)) {
    c !== l && ((e.snapIndex = c), e.emit('snapIndexChange'));
    return;
  }
  if (a === r && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = f(a);
    return;
  }
  const u = e.grid && n.grid && n.grid.rows > 1;
  let h;
  if (e.virtual && n.virtual.enabled && n.loop) h = f(a);
  else if (u) {
    const m = e.slides.filter((y) => y.column === a)[0];
    let v = parseInt(m.getAttribute('data-swiper-slide-index'), 10);
    Number.isNaN(v) && (v = Math.max(e.slides.indexOf(m), 0)), (h = Math.floor(v / n.grid.rows));
  } else if (e.slides[a]) {
    const m = e.slides[a].getAttribute('data-swiper-slide-index');
    m ? (h = parseInt(m, 10)) : (h = a);
  } else h = a;
  Object.assign(e, {
    previousSnapIndex: l,
    snapIndex: c,
    previousRealIndex: o,
    realIndex: h,
    previousIndex: r,
    activeIndex: a,
  }),
    e.initialized && oe(e),
    e.emit('activeIndexChange'),
    e.emit('snapIndexChange'),
    (e.initialized || e.params.runCallbacksOnInit) && (o !== h && e.emit('realIndexChange'), e.emit('slideChange'));
}
function Xe(i, e) {
  const t = this,
    s = t.params;
  let n = i.closest(`.${s.slideClass}, swiper-slide`);
  !n &&
    t.isElement &&
    e &&
    e.length > 1 &&
    e.includes(i) &&
    [...e.slice(e.indexOf(i) + 1, e.length)].forEach((l) => {
      !n && l.matches && l.matches(`.${s.slideClass}, swiper-slide`) && (n = l);
    });
  let r = !1,
    o;
  if (n) {
    for (let l = 0; l < t.slides.length; l += 1)
      if (t.slides[l] === n) {
        (r = !0), (o = l);
        break;
      }
  }
  if (n && r)
    (t.clickedSlide = n),
      t.virtual && t.params.virtual.enabled
        ? (t.clickedIndex = parseInt(n.getAttribute('data-swiper-slide-index'), 10))
        : (t.clickedIndex = o);
  else {
    (t.clickedSlide = void 0), (t.clickedIndex = void 0);
    return;
  }
  s.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
}
var Ue = {
  updateSize: Fe,
  updateSlides: Ne,
  updateAutoHeight: _e,
  updateSlidesOffset: Re,
  updateSlidesProgress: He,
  updateProgress: We,
  updateSlidesClasses: qe,
  updateActiveIndex: Ye,
  updateClickedSlide: Xe,
};
function Ke(i) {
  i === void 0 && (i = this.isHorizontal() ? 'x' : 'y');
  const e = this,
    {params: t, rtlTranslate: s, translate: n, wrapperEl: r} = e;
  if (t.virtualTranslate) return s ? -n : n;
  if (t.cssMode) return n;
  let o = Pe(r, i);
  return (o += e.cssOverflowAdjustment()), s && (o = -o), o || 0;
}
function Je(i, e) {
  const t = this,
    {rtlTranslate: s, params: n, wrapperEl: r, progress: o} = t;
  let l = 0,
    a = 0;
  const c = 0;
  t.isHorizontal() ? (l = s ? -i : i) : (a = i),
    n.roundLengths && ((l = Math.floor(l)), (a = Math.floor(a))),
    (t.previousTranslate = t.translate),
    (t.translate = t.isHorizontal() ? l : a),
    n.cssMode
      ? (r[t.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = t.isHorizontal() ? -l : -a)
      : n.virtualTranslate ||
        (t.isHorizontal() ? (l -= t.cssOverflowAdjustment()) : (a -= t.cssOverflowAdjustment()),
        (r.style.transform = `translate3d(${l}px, ${a}px, ${c}px)`));
  let f;
  const u = t.maxTranslate() - t.minTranslate();
  u === 0 ? (f = 0) : (f = (i - t.minTranslate()) / u),
    f !== o && t.updateProgress(i),
    t.emit('setTranslate', t.translate, e);
}
function Qe() {
  return -this.snapGrid[0];
}
function Ze() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function et(i, e, t, s, n) {
  i === void 0 && (i = 0), e === void 0 && (e = this.params.speed), t === void 0 && (t = !0), s === void 0 && (s = !0);
  const r = this,
    {params: o, wrapperEl: l} = r;
  if (r.animating && o.preventInteractionOnTransition) return !1;
  const a = r.minTranslate(),
    c = r.maxTranslate();
  let f;
  if ((s && i > a ? (f = a) : s && i < c ? (f = c) : (f = i), r.updateProgress(f), o.cssMode)) {
    const u = r.isHorizontal();
    if (e === 0) l[u ? 'scrollLeft' : 'scrollTop'] = -f;
    else {
      if (!r.support.smoothScroll) return ge({swiper: r, targetPosition: -f, side: u ? 'left' : 'top'}), !0;
      l.scrollTo({[u ? 'left' : 'top']: -f, behavior: 'smooth'});
    }
    return !0;
  }
  return (
    e === 0
      ? (r.setTransition(0), r.setTranslate(f), t && (r.emit('beforeTransitionStart', e, n), r.emit('transitionEnd')))
      : (r.setTransition(e),
        r.setTranslate(f),
        t && (r.emit('beforeTransitionStart', e, n), r.emit('transitionStart')),
        r.animating ||
          ((r.animating = !0),
          r.onTranslateToWrapperTransitionEnd ||
            (r.onTranslateToWrapperTransitionEnd = function (h) {
              !r ||
                r.destroyed ||
                (h.target === this &&
                  (r.wrapperEl.removeEventListener('transitionend', r.onTranslateToWrapperTransitionEnd),
                  (r.onTranslateToWrapperTransitionEnd = null),
                  delete r.onTranslateToWrapperTransitionEnd,
                  t && r.emit('transitionEnd')));
            }),
          r.wrapperEl.addEventListener('transitionend', r.onTranslateToWrapperTransitionEnd))),
    !0
  );
}
var tt = {getTranslate: Ke, setTranslate: Je, minTranslate: Qe, maxTranslate: Ze, translateTo: et};
function it(i, e) {
  const t = this;
  t.params.cssMode ||
    ((t.wrapperEl.style.transitionDuration = `${i}ms`), (t.wrapperEl.style.transitionDelay = i === 0 ? '0ms' : '')),
    t.emit('setTransition', i, e);
}
function Te(i) {
  let {swiper: e, runCallbacks: t, direction: s, step: n} = i;
  const {activeIndex: r, previousIndex: o} = e;
  let l = s;
  if ((l || (r > o ? (l = 'next') : r < o ? (l = 'prev') : (l = 'reset')), e.emit(`transition${n}`), t && r !== o)) {
    if (l === 'reset') {
      e.emit(`slideResetTransition${n}`);
      return;
    }
    e.emit(`slideChangeTransition${n}`),
      l === 'next' ? e.emit(`slideNextTransition${n}`) : e.emit(`slidePrevTransition${n}`);
  }
}
function st(i, e) {
  i === void 0 && (i = !0);
  const t = this,
    {params: s} = t;
  s.cssMode || (s.autoHeight && t.updateAutoHeight(), Te({swiper: t, runCallbacks: i, direction: e, step: 'Start'}));
}
function rt(i, e) {
  i === void 0 && (i = !0);
  const t = this,
    {params: s} = t;
  (t.animating = !1), !s.cssMode && (t.setTransition(0), Te({swiper: t, runCallbacks: i, direction: e, step: 'End'}));
}
var nt = {setTransition: it, transitionStart: st, transitionEnd: rt};
function at(i, e, t, s, n) {
  i === void 0 && (i = 0),
    e === void 0 && (e = this.params.speed),
    t === void 0 && (t = !0),
    typeof i == 'string' && (i = parseInt(i, 10));
  const r = this;
  let o = i;
  o < 0 && (o = 0);
  const {
    params: l,
    snapGrid: a,
    slidesGrid: c,
    previousIndex: f,
    activeIndex: u,
    rtlTranslate: h,
    wrapperEl: m,
    enabled: v,
  } = r;
  if ((r.animating && l.preventInteractionOnTransition) || (!v && !s && !n) || r.destroyed) return !1;
  const y = Math.min(r.params.slidesPerGroupSkip, o);
  let M = y + Math.floor((o - y) / r.params.slidesPerGroup);
  M >= a.length && (M = a.length - 1);
  const d = -a[M];
  if (l.normalizeSlideIndex)
    for (let g = 0; g < c.length; g += 1) {
      const S = -Math.floor(d * 100),
        b = Math.floor(c[g] * 100),
        P = Math.floor(c[g + 1] * 100);
      typeof c[g + 1] < 'u'
        ? S >= b && S < P - (P - b) / 2
          ? (o = g)
          : S >= b && S < P && (o = g + 1)
        : S >= b && (o = g);
    }
  if (
    r.initialized &&
    o !== u &&
    ((!r.allowSlideNext && (h ? d > r.translate && d > r.minTranslate() : d < r.translate && d < r.minTranslate())) ||
      (!r.allowSlidePrev && d > r.translate && d > r.maxTranslate() && (u || 0) !== o))
  )
    return !1;
  o !== (f || 0) && t && r.emit('beforeSlideChangeStart'), r.updateProgress(d);
  let p;
  if (
    (o > u ? (p = 'next') : o < u ? (p = 'prev') : (p = 'reset'),
    (h && -d === r.translate) || (!h && d === r.translate))
  )
    return (
      r.updateActiveIndex(o),
      l.autoHeight && r.updateAutoHeight(),
      r.updateSlidesClasses(),
      l.effect !== 'slide' && r.setTranslate(d),
      p !== 'reset' && (r.transitionStart(t, p), r.transitionEnd(t, p)),
      !1
    );
  if (l.cssMode) {
    const g = r.isHorizontal(),
      S = h ? d : -d;
    if (e === 0) {
      const b = r.virtual && r.params.virtual.enabled;
      b && ((r.wrapperEl.style.scrollSnapType = 'none'), (r._immediateVirtual = !0)),
        b && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0
          ? ((r._cssModeVirtualInitialSet = !0),
            requestAnimationFrame(() => {
              m[g ? 'scrollLeft' : 'scrollTop'] = S;
            }))
          : (m[g ? 'scrollLeft' : 'scrollTop'] = S),
        b &&
          requestAnimationFrame(() => {
            (r.wrapperEl.style.scrollSnapType = ''), (r._immediateVirtual = !1);
          });
    } else {
      if (!r.support.smoothScroll) return ge({swiper: r, targetPosition: S, side: g ? 'left' : 'top'}), !0;
      m.scrollTo({[g ? 'left' : 'top']: S, behavior: 'smooth'});
    }
    return !0;
  }
  return (
    r.setTransition(e),
    r.setTranslate(d),
    r.updateActiveIndex(o),
    r.updateSlidesClasses(),
    r.emit('beforeTransitionStart', e, s),
    r.transitionStart(t, p),
    e === 0
      ? r.transitionEnd(t, p)
      : r.animating ||
        ((r.animating = !0),
        r.onSlideToWrapperTransitionEnd ||
          (r.onSlideToWrapperTransitionEnd = function (S) {
            !r ||
              r.destroyed ||
              (S.target === this &&
                (r.wrapperEl.removeEventListener('transitionend', r.onSlideToWrapperTransitionEnd),
                (r.onSlideToWrapperTransitionEnd = null),
                delete r.onSlideToWrapperTransitionEnd,
                r.transitionEnd(t, p)));
          }),
        r.wrapperEl.addEventListener('transitionend', r.onSlideToWrapperTransitionEnd)),
    !0
  );
}
function lt(i, e, t, s) {
  i === void 0 && (i = 0),
    e === void 0 && (e = this.params.speed),
    t === void 0 && (t = !0),
    typeof i == 'string' && (i = parseInt(i, 10));
  const n = this;
  if (n.destroyed) return;
  const r = n.grid && n.params.grid && n.params.grid.rows > 1;
  let o = i;
  if (n.params.loop)
    if (n.virtual && n.params.virtual.enabled) o = o + n.virtual.slidesBefore;
    else {
      let l;
      if (r) {
        const h = o * n.params.grid.rows;
        l = n.slides.filter((m) => m.getAttribute('data-swiper-slide-index') * 1 === h)[0].column;
      } else l = n.getSlideIndexByData(o);
      const a = r ? Math.ceil(n.slides.length / n.params.grid.rows) : n.slides.length,
        {centeredSlides: c} = n.params;
      let f = n.params.slidesPerView;
      f === 'auto'
        ? (f = n.slidesPerViewDynamic())
        : ((f = Math.ceil(parseFloat(n.params.slidesPerView, 10))), c && f % 2 === 0 && (f = f + 1));
      let u = a - l < f;
      if ((c && (u = u || l < Math.ceil(f / 2)), u)) {
        const h = c
          ? l < n.activeIndex
            ? 'prev'
            : 'next'
          : l - n.activeIndex - 1 < n.params.slidesPerView
            ? 'next'
            : 'prev';
        n.loopFix({
          direction: h,
          slideTo: !0,
          activeSlideIndex: h === 'next' ? l + 1 : l - a + 1,
          slideRealIndex: h === 'next' ? n.realIndex : void 0,
        });
      }
      if (r) {
        const h = o * n.params.grid.rows;
        o = n.slides.filter((m) => m.getAttribute('data-swiper-slide-index') * 1 === h)[0].column;
      } else o = n.getSlideIndexByData(o);
    }
  return (
    requestAnimationFrame(() => {
      n.slideTo(o, e, t, s);
    }),
    n
  );
}
function ot(i, e, t) {
  i === void 0 && (i = this.params.speed), e === void 0 && (e = !0);
  const s = this,
    {enabled: n, params: r, animating: o} = s;
  if (!n || s.destroyed) return s;
  let l = r.slidesPerGroup;
  r.slidesPerView === 'auto' &&
    r.slidesPerGroup === 1 &&
    r.slidesPerGroupAuto &&
    (l = Math.max(s.slidesPerViewDynamic('current', !0), 1));
  const a = s.activeIndex < r.slidesPerGroupSkip ? 1 : l,
    c = s.virtual && r.virtual.enabled;
  if (r.loop) {
    if (o && !c && r.loopPreventsSliding) return !1;
    if (
      (s.loopFix({direction: 'next'}),
      (s._clientLeft = s.wrapperEl.clientLeft),
      s.activeIndex === s.slides.length - 1 && r.cssMode)
    )
      return (
        requestAnimationFrame(() => {
          s.slideTo(s.activeIndex + a, i, e, t);
        }),
        !0
      );
  }
  return r.rewind && s.isEnd ? s.slideTo(0, i, e, t) : s.slideTo(s.activeIndex + a, i, e, t);
}
function dt(i, e, t) {
  i === void 0 && (i = this.params.speed), e === void 0 && (e = !0);
  const s = this,
    {params: n, snapGrid: r, slidesGrid: o, rtlTranslate: l, enabled: a, animating: c} = s;
  if (!a || s.destroyed) return s;
  const f = s.virtual && n.virtual.enabled;
  if (n.loop) {
    if (c && !f && n.loopPreventsSliding) return !1;
    s.loopFix({direction: 'prev'}), (s._clientLeft = s.wrapperEl.clientLeft);
  }
  const u = l ? s.translate : -s.translate;
  function h(d) {
    return d < 0 ? -Math.floor(Math.abs(d)) : Math.floor(d);
  }
  const m = h(u),
    v = r.map((d) => h(d));
  let y = r[v.indexOf(m) - 1];
  if (typeof y > 'u' && n.cssMode) {
    let d;
    r.forEach((p, g) => {
      m >= p && (d = g);
    }),
      typeof d < 'u' && (y = r[d > 0 ? d - 1 : d]);
  }
  let M = 0;
  if (
    (typeof y < 'u' &&
      ((M = o.indexOf(y)),
      M < 0 && (M = s.activeIndex - 1),
      n.slidesPerView === 'auto' &&
        n.slidesPerGroup === 1 &&
        n.slidesPerGroupAuto &&
        ((M = M - s.slidesPerViewDynamic('previous', !0) + 1), (M = Math.max(M, 0)))),
    n.rewind && s.isBeginning)
  ) {
    const d =
      s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
    return s.slideTo(d, i, e, t);
  } else if (n.loop && s.activeIndex === 0 && n.cssMode)
    return (
      requestAnimationFrame(() => {
        s.slideTo(M, i, e, t);
      }),
      !0
    );
  return s.slideTo(M, i, e, t);
}
function ct(i, e, t) {
  i === void 0 && (i = this.params.speed), e === void 0 && (e = !0);
  const s = this;
  if (!s.destroyed) return s.slideTo(s.activeIndex, i, e, t);
}
function ft(i, e, t, s) {
  i === void 0 && (i = this.params.speed), e === void 0 && (e = !0), s === void 0 && (s = 0.5);
  const n = this;
  if (n.destroyed) return;
  let r = n.activeIndex;
  const o = Math.min(n.params.slidesPerGroupSkip, r),
    l = o + Math.floor((r - o) / n.params.slidesPerGroup),
    a = n.rtlTranslate ? n.translate : -n.translate;
  if (a >= n.snapGrid[l]) {
    const c = n.snapGrid[l],
      f = n.snapGrid[l + 1];
    a - c > (f - c) * s && (r += n.params.slidesPerGroup);
  } else {
    const c = n.snapGrid[l - 1],
      f = n.snapGrid[l];
    a - c <= (f - c) * s && (r -= n.params.slidesPerGroup);
  }
  return (r = Math.max(r, 0)), (r = Math.min(r, n.slidesGrid.length - 1)), n.slideTo(r, i, e, t);
}
function ut() {
  const i = this;
  if (i.destroyed) return;
  const {params: e, slidesEl: t} = i,
    s = e.slidesPerView === 'auto' ? i.slidesPerViewDynamic() : e.slidesPerView;
  let n = i.clickedIndex,
    r;
  const o = i.isElement ? 'swiper-slide' : `.${e.slideClass}`;
  if (e.loop) {
    if (i.animating) return;
    (r = parseInt(i.clickedSlide.getAttribute('data-swiper-slide-index'), 10)),
      e.centeredSlides
        ? n < i.loopedSlides - s / 2 || n > i.slides.length - i.loopedSlides + s / 2
          ? (i.loopFix(),
            (n = i.getSlideIndex(F(t, `${o}[data-swiper-slide-index="${r}"]`)[0])),
            ae(() => {
              i.slideTo(n);
            }))
          : i.slideTo(n)
        : n > i.slides.length - s
          ? (i.loopFix(),
            (n = i.getSlideIndex(F(t, `${o}[data-swiper-slide-index="${r}"]`)[0])),
            ae(() => {
              i.slideTo(n);
            }))
          : i.slideTo(n);
  } else i.slideTo(n);
}
var pt = {
  slideTo: at,
  slideToLoop: lt,
  slideNext: ot,
  slidePrev: dt,
  slideReset: ct,
  slideToClosest: ft,
  slideToClickedSlide: ut,
};
function mt(i) {
  const e = this,
    {params: t, slidesEl: s} = e;
  if (!t.loop || (e.virtual && e.params.virtual.enabled)) return;
  const n = () => {
      F(s, `.${t.slideClass}, swiper-slide`).forEach((u, h) => {
        u.setAttribute('data-swiper-slide-index', h);
      });
    },
    r = e.grid && t.grid && t.grid.rows > 1,
    o = t.slidesPerGroup * (r ? t.grid.rows : 1),
    l = e.slides.length % o !== 0,
    a = r && e.slides.length % t.grid.rows !== 0,
    c = (f) => {
      for (let u = 0; u < f; u += 1) {
        const h = e.isElement ? J('swiper-slide', [t.slideBlankClass]) : J('div', [t.slideClass, t.slideBlankClass]);
        e.slidesEl.append(h);
      }
    };
  if (l) {
    if (t.loopAddBlankSlides) {
      const f = o - (e.slides.length % o);
      c(f), e.recalcSlides(), e.updateSlides();
    } else
      K(
        'Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
      );
    n();
  } else if (a) {
    if (t.loopAddBlankSlides) {
      const f = t.grid.rows - (e.slides.length % t.grid.rows);
      c(f), e.recalcSlides(), e.updateSlides();
    } else
      K(
        'Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
      );
    n();
  } else n();
  e.loopFix({slideRealIndex: i, direction: t.centeredSlides ? void 0 : 'next'});
}
function ht(i) {
  let {
    slideRealIndex: e,
    slideTo: t = !0,
    direction: s,
    setTranslate: n,
    activeSlideIndex: r,
    byController: o,
    byMousewheel: l,
  } = i === void 0 ? {} : i;
  const a = this;
  if (!a.params.loop) return;
  a.emit('beforeLoopFix');
  const {slides: c, allowSlidePrev: f, allowSlideNext: u, slidesEl: h, params: m} = a,
    {centeredSlides: v} = m;
  if (((a.allowSlidePrev = !0), (a.allowSlideNext = !0), a.virtual && m.virtual.enabled)) {
    t &&
      (!m.centeredSlides && a.snapIndex === 0
        ? a.slideTo(a.virtual.slides.length, 0, !1, !0)
        : m.centeredSlides && a.snapIndex < m.slidesPerView
          ? a.slideTo(a.virtual.slides.length + a.snapIndex, 0, !1, !0)
          : a.snapIndex === a.snapGrid.length - 1 && a.slideTo(a.virtual.slidesBefore, 0, !1, !0)),
      (a.allowSlidePrev = f),
      (a.allowSlideNext = u),
      a.emit('loopFix');
    return;
  }
  let y = m.slidesPerView;
  y === 'auto'
    ? (y = a.slidesPerViewDynamic())
    : ((y = Math.ceil(parseFloat(m.slidesPerView, 10))), v && y % 2 === 0 && (y = y + 1));
  const M = m.slidesPerGroupAuto ? y : m.slidesPerGroup;
  let d = M;
  d % M !== 0 && (d += M - (d % M)), (d += m.loopAdditionalSlides), (a.loopedSlides = d);
  const p = a.grid && m.grid && m.grid.rows > 1;
  c.length < y + d
    ? K(
        'Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters'
      )
    : p && m.grid.fill === 'row' && K('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
  const g = [],
    S = [];
  let b = a.activeIndex;
  typeof r > 'u' ? (r = a.getSlideIndex(c.filter((T) => T.classList.contains(m.slideActiveClass))[0])) : (b = r);
  const P = s === 'next' || !s,
    D = s === 'prev' || !s;
  let C = 0,
    O = 0;
  const w = p ? Math.ceil(c.length / m.grid.rows) : c.length,
    x = (p ? c[r].column : r) + (v && typeof n > 'u' ? -y / 2 + 0.5 : 0);
  if (x < d) {
    C = Math.max(d - x, M);
    for (let T = 0; T < d - x; T += 1) {
      const L = T - Math.floor(T / w) * w;
      if (p) {
        const A = w - L - 1;
        for (let B = c.length - 1; B >= 0; B -= 1) c[B].column === A && g.push(B);
      } else g.push(w - L - 1);
    }
  } else if (x + y > w - d) {
    O = Math.max(x - (w - d * 2), M);
    for (let T = 0; T < O; T += 1) {
      const L = T - Math.floor(T / w) * w;
      p
        ? c.forEach((A, B) => {
            A.column === L && S.push(B);
          })
        : S.push(L);
    }
  }
  if (
    ((a.__preventObserver__ = !0),
    requestAnimationFrame(() => {
      a.__preventObserver__ = !1;
    }),
    D &&
      g.forEach((T) => {
        (c[T].swiperLoopMoveDOM = !0), h.prepend(c[T]), (c[T].swiperLoopMoveDOM = !1);
      }),
    P &&
      S.forEach((T) => {
        (c[T].swiperLoopMoveDOM = !0), h.append(c[T]), (c[T].swiperLoopMoveDOM = !1);
      }),
    a.recalcSlides(),
    m.slidesPerView === 'auto'
      ? a.updateSlides()
      : p &&
        ((g.length > 0 && D) || (S.length > 0 && P)) &&
        a.slides.forEach((T, L) => {
          a.grid.updateSlide(L, T, a.slides);
        }),
    m.watchSlidesProgress && a.updateSlidesOffset(),
    t)
  ) {
    if (g.length > 0 && D) {
      if (typeof e > 'u') {
        const T = a.slidesGrid[b],
          A = a.slidesGrid[b + C] - T;
        l
          ? a.setTranslate(a.translate - A)
          : (a.slideTo(b + Math.ceil(C), 0, !1, !0),
            n &&
              ((a.touchEventsData.startTranslate = a.touchEventsData.startTranslate - A),
              (a.touchEventsData.currentTranslate = a.touchEventsData.currentTranslate - A)));
      } else if (n) {
        const T = p ? g.length / m.grid.rows : g.length;
        a.slideTo(a.activeIndex + T, 0, !1, !0), (a.touchEventsData.currentTranslate = a.translate);
      }
    } else if (S.length > 0 && P)
      if (typeof e > 'u') {
        const T = a.slidesGrid[b],
          A = a.slidesGrid[b - O] - T;
        l
          ? a.setTranslate(a.translate - A)
          : (a.slideTo(b - O, 0, !1, !0),
            n &&
              ((a.touchEventsData.startTranslate = a.touchEventsData.startTranslate - A),
              (a.touchEventsData.currentTranslate = a.touchEventsData.currentTranslate - A)));
      } else {
        const T = p ? S.length / m.grid.rows : S.length;
        a.slideTo(a.activeIndex - T, 0, !1, !0);
      }
  }
  if (((a.allowSlidePrev = f), (a.allowSlideNext = u), a.controller && a.controller.control && !o)) {
    const T = {slideRealIndex: e, direction: s, setTranslate: n, activeSlideIndex: r, byController: !0};
    Array.isArray(a.controller.control)
      ? a.controller.control.forEach((L) => {
          !L.destroyed &&
            L.params.loop &&
            L.loopFix({...T, slideTo: L.params.slidesPerView === m.slidesPerView ? t : !1});
        })
      : a.controller.control instanceof a.constructor &&
        a.controller.control.params.loop &&
        a.controller.control.loopFix({
          ...T,
          slideTo: a.controller.control.params.slidesPerView === m.slidesPerView ? t : !1,
        });
  }
  a.emit('loopFix');
}
function gt() {
  const i = this,
    {params: e, slidesEl: t} = i;
  if (!e.loop || (i.virtual && i.params.virtual.enabled)) return;
  i.recalcSlides();
  const s = [];
  i.slides.forEach((n) => {
    const r = typeof n.swiperSlideIndex > 'u' ? n.getAttribute('data-swiper-slide-index') * 1 : n.swiperSlideIndex;
    s[r] = n;
  }),
    i.slides.forEach((n) => {
      n.removeAttribute('data-swiper-slide-index');
    }),
    s.forEach((n) => {
      t.append(n);
    }),
    i.recalcSlides(),
    i.slideTo(i.realIndex, 0);
}
var vt = {loopCreate: mt, loopFix: ht, loopDestroy: gt};
function wt(i) {
  const e = this;
  if (!e.params.simulateTouch || (e.params.watchOverflow && e.isLocked) || e.params.cssMode) return;
  const t = e.params.touchEventsTarget === 'container' ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0),
    (t.style.cursor = 'move'),
    (t.style.cursor = i ? 'grabbing' : 'grab'),
    e.isElement &&
      requestAnimationFrame(() => {
        e.__preventObserver__ = !1;
      });
}
function St() {
  const i = this;
  (i.params.watchOverflow && i.isLocked) ||
    i.params.cssMode ||
    (i.isElement && (i.__preventObserver__ = !0),
    (i[i.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = ''),
    i.isElement &&
      requestAnimationFrame(() => {
        i.__preventObserver__ = !1;
      }));
}
var yt = {setGrabCursor: wt, unsetGrabCursor: St};
function Tt(i, e) {
  e === void 0 && (e = this);
  function t(s) {
    if (!s || s === _() || s === G()) return null;
    s.assignedSlot && (s = s.assignedSlot);
    const n = s.closest(i);
    return !n && !s.getRootNode ? null : n || t(s.getRootNode().host);
  }
  return t(e);
}
function fe(i, e, t) {
  const s = G(),
    {params: n} = i,
    r = n.edgeSwipeDetection,
    o = n.edgeSwipeThreshold;
  return r && (t <= o || t >= s.innerWidth - o) ? (r === 'prevent' ? (e.preventDefault(), !0) : !1) : !0;
}
function bt(i) {
  const e = this,
    t = _();
  let s = i;
  s.originalEvent && (s = s.originalEvent);
  const n = e.touchEventsData;
  if (s.type === 'pointerdown') {
    if (n.pointerId !== null && n.pointerId !== s.pointerId) return;
    n.pointerId = s.pointerId;
  } else s.type === 'touchstart' && s.targetTouches.length === 1 && (n.touchId = s.targetTouches[0].identifier);
  if (s.type === 'touchstart') {
    fe(e, s, s.targetTouches[0].pageX);
    return;
  }
  const {params: r, touches: o, enabled: l} = e;
  if (!l || (!r.simulateTouch && s.pointerType === 'mouse') || (e.animating && r.preventInteractionOnTransition))
    return;
  !e.animating && r.cssMode && r.loop && e.loopFix();
  let a = s.target;
  if (
    (r.touchEventsTarget === 'wrapper' && !e.wrapperEl.contains(a)) ||
    ('which' in s && s.which === 3) ||
    ('button' in s && s.button > 0) ||
    (n.isTouched && n.isMoved)
  )
    return;
  const c = !!r.noSwipingClass && r.noSwipingClass !== '',
    f = s.composedPath ? s.composedPath() : s.path;
  c && s.target && s.target.shadowRoot && f && (a = f[0]);
  const u = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`,
    h = !!(s.target && s.target.shadowRoot);
  if (r.noSwiping && (h ? Tt(u, a) : a.closest(u))) {
    e.allowClick = !0;
    return;
  }
  if (r.swipeHandler && !a.closest(r.swipeHandler)) return;
  (o.currentX = s.pageX), (o.currentY = s.pageY);
  const m = o.currentX,
    v = o.currentY;
  if (!fe(e, s, m)) return;
  Object.assign(n, {isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0}),
    (o.startX = m),
    (o.startY = v),
    (n.touchStartTime = U()),
    (e.allowClick = !0),
    e.updateSize(),
    (e.swipeDirection = void 0),
    r.threshold > 0 && (n.allowThresholdMove = !1);
  let y = !0;
  a.matches(n.focusableElements) && ((y = !1), a.nodeName === 'SELECT' && (n.isTouched = !1)),
    t.activeElement && t.activeElement.matches(n.focusableElements) && t.activeElement !== a && t.activeElement.blur();
  const M = y && e.allowTouchMove && r.touchStartPreventDefault;
  (r.touchStartForcePreventDefault || M) && !a.isContentEditable && s.preventDefault(),
    r.freeMode && r.freeMode.enabled && e.freeMode && e.animating && !r.cssMode && e.freeMode.onTouchStart(),
    e.emit('touchStart', s);
}
function xt(i) {
  const e = _(),
    t = this,
    s = t.touchEventsData,
    {params: n, touches: r, rtlTranslate: o, enabled: l} = t;
  if (!l || (!n.simulateTouch && i.pointerType === 'mouse')) return;
  let a = i;
  if (
    (a.originalEvent && (a = a.originalEvent),
    a.type === 'pointermove' && (s.touchId !== null || a.pointerId !== s.pointerId))
  )
    return;
  let c;
  if (a.type === 'touchmove') {
    if (((c = [...a.changedTouches].filter((P) => P.identifier === s.touchId)[0]), !c || c.identifier !== s.touchId))
      return;
  } else c = a;
  if (!s.isTouched) {
    s.startMoving && s.isScrolling && t.emit('touchMoveOpposite', a);
    return;
  }
  const f = c.pageX,
    u = c.pageY;
  if (a.preventedByNestedSwiper) {
    (r.startX = f), (r.startY = u);
    return;
  }
  if (!t.allowTouchMove) {
    a.target.matches(s.focusableElements) || (t.allowClick = !1),
      s.isTouched && (Object.assign(r, {startX: f, startY: u, currentX: f, currentY: u}), (s.touchStartTime = U()));
    return;
  }
  if (n.touchReleaseOnEdges && !n.loop) {
    if (t.isVertical()) {
      if ((u < r.startY && t.translate <= t.maxTranslate()) || (u > r.startY && t.translate >= t.minTranslate())) {
        (s.isTouched = !1), (s.isMoved = !1);
        return;
      }
    } else if ((f < r.startX && t.translate <= t.maxTranslate()) || (f > r.startX && t.translate >= t.minTranslate()))
      return;
  }
  if (e.activeElement && a.target === e.activeElement && a.target.matches(s.focusableElements)) {
    (s.isMoved = !0), (t.allowClick = !1);
    return;
  }
  s.allowTouchCallbacks && t.emit('touchMove', a),
    (r.previousX = r.currentX),
    (r.previousY = r.currentY),
    (r.currentX = f),
    (r.currentY = u);
  const h = r.currentX - r.startX,
    m = r.currentY - r.startY;
  if (t.params.threshold && Math.sqrt(h ** 2 + m ** 2) < t.params.threshold) return;
  if (typeof s.isScrolling > 'u') {
    let P;
    (t.isHorizontal() && r.currentY === r.startY) || (t.isVertical() && r.currentX === r.startX)
      ? (s.isScrolling = !1)
      : h * h + m * m >= 25 &&
        ((P = (Math.atan2(Math.abs(m), Math.abs(h)) * 180) / Math.PI),
        (s.isScrolling = t.isHorizontal() ? P > n.touchAngle : 90 - P > n.touchAngle));
  }
  if (
    (s.isScrolling && t.emit('touchMoveOpposite', a),
    typeof s.startMoving > 'u' && (r.currentX !== r.startX || r.currentY !== r.startY) && (s.startMoving = !0),
    s.isScrolling)
  ) {
    s.isTouched = !1;
    return;
  }
  if (!s.startMoving) return;
  (t.allowClick = !1),
    !n.cssMode && a.cancelable && a.preventDefault(),
    n.touchMoveStopPropagation && !n.nested && a.stopPropagation();
  let v = t.isHorizontal() ? h : m,
    y = t.isHorizontal() ? r.currentX - r.previousX : r.currentY - r.previousY;
  n.oneWayMovement && ((v = Math.abs(v) * (o ? 1 : -1)), (y = Math.abs(y) * (o ? 1 : -1))),
    (r.diff = v),
    (v *= n.touchRatio),
    o && ((v = -v), (y = -y));
  const M = t.touchesDirection;
  (t.swipeDirection = v > 0 ? 'prev' : 'next'), (t.touchesDirection = y > 0 ? 'prev' : 'next');
  const d = t.params.loop && !n.cssMode,
    p = (t.touchesDirection === 'next' && t.allowSlideNext) || (t.touchesDirection === 'prev' && t.allowSlidePrev);
  if (!s.isMoved) {
    if (
      (d && p && t.loopFix({direction: t.swipeDirection}),
      (s.startTranslate = t.getTranslate()),
      t.setTransition(0),
      t.animating)
    ) {
      const P = new window.CustomEvent('transitionend', {bubbles: !0, cancelable: !0});
      t.wrapperEl.dispatchEvent(P);
    }
    (s.allowMomentumBounce = !1),
      n.grabCursor && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!0),
      t.emit('sliderFirstMove', a);
  }
  let g;
  if (
    (new Date().getTime(), s.isMoved && s.allowThresholdMove && M !== t.touchesDirection && d && p && Math.abs(v) >= 1)
  ) {
    Object.assign(r, {startX: f, startY: u, currentX: f, currentY: u, startTranslate: s.currentTranslate}),
      (s.loopSwapReset = !0),
      (s.startTranslate = s.currentTranslate);
    return;
  }
  t.emit('sliderMove', a), (s.isMoved = !0), (s.currentTranslate = v + s.startTranslate);
  let S = !0,
    b = n.resistanceRatio;
  if (
    (n.touchReleaseOnEdges && (b = 0),
    v > 0
      ? (d &&
          p &&
          !g &&
          s.allowThresholdMove &&
          s.currentTranslate >
            (n.centeredSlides ? t.minTranslate() - t.slidesSizesGrid[t.activeIndex + 1] : t.minTranslate()) &&
          t.loopFix({direction: 'prev', setTranslate: !0, activeSlideIndex: 0}),
        s.currentTranslate > t.minTranslate() &&
          ((S = !1),
          n.resistance &&
            (s.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + s.startTranslate + v) ** b)))
      : v < 0 &&
        (d &&
          p &&
          !g &&
          s.allowThresholdMove &&
          s.currentTranslate <
            (n.centeredSlides
              ? t.maxTranslate() + t.slidesSizesGrid[t.slidesSizesGrid.length - 1]
              : t.maxTranslate()) &&
          t.loopFix({
            direction: 'next',
            setTranslate: !0,
            activeSlideIndex:
              t.slides.length -
              (n.slidesPerView === 'auto' ? t.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10))),
          }),
        s.currentTranslate < t.maxTranslate() &&
          ((S = !1),
          n.resistance &&
            (s.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - s.startTranslate - v) ** b))),
    S && (a.preventedByNestedSwiper = !0),
    !t.allowSlideNext &&
      t.swipeDirection === 'next' &&
      s.currentTranslate < s.startTranslate &&
      (s.currentTranslate = s.startTranslate),
    !t.allowSlidePrev &&
      t.swipeDirection === 'prev' &&
      s.currentTranslate > s.startTranslate &&
      (s.currentTranslate = s.startTranslate),
    !t.allowSlidePrev && !t.allowSlideNext && (s.currentTranslate = s.startTranslate),
    n.threshold > 0)
  )
    if (Math.abs(v) > n.threshold || s.allowThresholdMove) {
      if (!s.allowThresholdMove) {
        (s.allowThresholdMove = !0),
          (r.startX = r.currentX),
          (r.startY = r.currentY),
          (s.currentTranslate = s.startTranslate),
          (r.diff = t.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY);
        return;
      }
    } else {
      s.currentTranslate = s.startTranslate;
      return;
    }
  !n.followFinger ||
    n.cssMode ||
    (((n.freeMode && n.freeMode.enabled && t.freeMode) || n.watchSlidesProgress) &&
      (t.updateActiveIndex(), t.updateSlidesClasses()),
    n.freeMode && n.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(),
    t.updateProgress(s.currentTranslate),
    t.setTranslate(s.currentTranslate));
}
function Et(i) {
  const e = this,
    t = e.touchEventsData;
  let s = i;
  s.originalEvent && (s = s.originalEvent);
  let n;
  if (s.type === 'touchend' || s.type === 'touchcancel') {
    if (((n = [...s.changedTouches].filter((b) => b.identifier === t.touchId)[0]), !n || n.identifier !== t.touchId))
      return;
  } else {
    if (t.touchId !== null || s.pointerId !== t.pointerId) return;
    n = s;
  }
  if (
    ['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(s.type) &&
    !(['pointercancel', 'contextmenu'].includes(s.type) && (e.browser.isSafari || e.browser.isWebView))
  )
    return;
  (t.pointerId = null), (t.touchId = null);
  const {params: o, touches: l, rtlTranslate: a, slidesGrid: c, enabled: f} = e;
  if (!f || (!o.simulateTouch && s.pointerType === 'mouse')) return;
  if ((t.allowTouchCallbacks && e.emit('touchEnd', s), (t.allowTouchCallbacks = !1), !t.isTouched)) {
    t.isMoved && o.grabCursor && e.setGrabCursor(!1), (t.isMoved = !1), (t.startMoving = !1);
    return;
  }
  o.grabCursor &&
    t.isMoved &&
    t.isTouched &&
    (e.allowSlideNext === !0 || e.allowSlidePrev === !0) &&
    e.setGrabCursor(!1);
  const u = U(),
    h = u - t.touchStartTime;
  if (e.allowClick) {
    const b = s.path || (s.composedPath && s.composedPath());
    e.updateClickedSlide((b && b[0]) || s.target, b),
      e.emit('tap click', s),
      h < 300 && u - t.lastClickTime < 300 && e.emit('doubleTap doubleClick', s);
  }
  if (
    ((t.lastClickTime = U()),
    ae(() => {
      e.destroyed || (e.allowClick = !0);
    }),
    !t.isTouched ||
      !t.isMoved ||
      !e.swipeDirection ||
      (l.diff === 0 && !t.loopSwapReset) ||
      (t.currentTranslate === t.startTranslate && !t.loopSwapReset))
  ) {
    (t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1);
    return;
  }
  (t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1);
  let m;
  if ((o.followFinger ? (m = a ? e.translate : -e.translate) : (m = -t.currentTranslate), o.cssMode)) return;
  if (o.freeMode && o.freeMode.enabled) {
    e.freeMode.onTouchEnd({currentPos: m});
    return;
  }
  const v = m >= -e.maxTranslate() && !e.params.loop;
  let y = 0,
    M = e.slidesSizesGrid[0];
  for (let b = 0; b < c.length; b += b < o.slidesPerGroupSkip ? 1 : o.slidesPerGroup) {
    const P = b < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
    typeof c[b + P] < 'u'
      ? (v || (m >= c[b] && m < c[b + P])) && ((y = b), (M = c[b + P] - c[b]))
      : (v || m >= c[b]) && ((y = b), (M = c[c.length - 1] - c[c.length - 2]));
  }
  let d = null,
    p = null;
  o.rewind &&
    (e.isBeginning
      ? (p = o.virtual && o.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1)
      : e.isEnd && (d = 0));
  const g = (m - c[y]) / M,
    S = y < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
  if (h > o.longSwipesMs) {
    if (!o.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === 'next' && (g >= o.longSwipesRatio ? e.slideTo(o.rewind && e.isEnd ? d : y + S) : e.slideTo(y)),
      e.swipeDirection === 'prev' &&
        (g > 1 - o.longSwipesRatio
          ? e.slideTo(y + S)
          : p !== null && g < 0 && Math.abs(g) > o.longSwipesRatio
            ? e.slideTo(p)
            : e.slideTo(y));
  } else {
    if (!o.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (s.target === e.navigation.nextEl || s.target === e.navigation.prevEl)
      ? s.target === e.navigation.nextEl
        ? e.slideTo(y + S)
        : e.slideTo(y)
      : (e.swipeDirection === 'next' && e.slideTo(d !== null ? d : y + S),
        e.swipeDirection === 'prev' && e.slideTo(p !== null ? p : y));
  }
}
function ue() {
  const i = this,
    {params: e, el: t} = i;
  if (t && t.offsetWidth === 0) return;
  e.breakpoints && i.setBreakpoint();
  const {allowSlideNext: s, allowSlidePrev: n, snapGrid: r} = i,
    o = i.virtual && i.params.virtual.enabled;
  (i.allowSlideNext = !0), (i.allowSlidePrev = !0), i.updateSize(), i.updateSlides(), i.updateSlidesClasses();
  const l = o && e.loop;
  (e.slidesPerView === 'auto' || e.slidesPerView > 1) && i.isEnd && !i.isBeginning && !i.params.centeredSlides && !l
    ? i.slideTo(i.slides.length - 1, 0, !1, !0)
    : i.params.loop && !o
      ? i.slideToLoop(i.realIndex, 0, !1, !0)
      : i.slideTo(i.activeIndex, 0, !1, !0),
    i.autoplay &&
      i.autoplay.running &&
      i.autoplay.paused &&
      (clearTimeout(i.autoplay.resizeTimeout),
      (i.autoplay.resizeTimeout = setTimeout(() => {
        i.autoplay && i.autoplay.running && i.autoplay.paused && i.autoplay.resume();
      }, 500))),
    (i.allowSlidePrev = n),
    (i.allowSlideNext = s),
    i.params.watchOverflow && r !== i.snapGrid && i.checkOverflow();
}
function Ct(i) {
  const e = this;
  e.enabled &&
    (e.allowClick ||
      (e.params.preventClicks && i.preventDefault(),
      e.params.preventClicksPropagation && e.animating && (i.stopPropagation(), i.stopImmediatePropagation())));
}
function Mt() {
  const i = this,
    {wrapperEl: e, rtlTranslate: t, enabled: s} = i;
  if (!s) return;
  (i.previousTranslate = i.translate),
    i.isHorizontal() ? (i.translate = -e.scrollLeft) : (i.translate = -e.scrollTop),
    i.translate === 0 && (i.translate = 0),
    i.updateActiveIndex(),
    i.updateSlidesClasses();
  let n;
  const r = i.maxTranslate() - i.minTranslate();
  r === 0 ? (n = 0) : (n = (i.translate - i.minTranslate()) / r),
    n !== i.progress && i.updateProgress(t ? -i.translate : i.translate),
    i.emit('setTranslate', i.translate, !1);
}
function Pt(i) {
  const e = this;
  X(e, i.target), !(e.params.cssMode || (e.params.slidesPerView !== 'auto' && !e.params.autoHeight)) && e.update();
}
function Lt() {
  const i = this;
  i.documentTouchHandlerProceeded ||
    ((i.documentTouchHandlerProceeded = !0), i.params.touchReleaseOnEdges && (i.el.style.touchAction = 'auto'));
}
const be = (i, e) => {
  const t = _(),
    {params: s, el: n, wrapperEl: r, device: o} = i,
    l = !!s.nested,
    a = e === 'on' ? 'addEventListener' : 'removeEventListener',
    c = e;
  t[a]('touchstart', i.onDocumentTouchStart, {passive: !1, capture: l}),
    n[a]('touchstart', i.onTouchStart, {passive: !1}),
    n[a]('pointerdown', i.onTouchStart, {passive: !1}),
    t[a]('touchmove', i.onTouchMove, {passive: !1, capture: l}),
    t[a]('pointermove', i.onTouchMove, {passive: !1, capture: l}),
    t[a]('touchend', i.onTouchEnd, {passive: !0}),
    t[a]('pointerup', i.onTouchEnd, {passive: !0}),
    t[a]('pointercancel', i.onTouchEnd, {passive: !0}),
    t[a]('touchcancel', i.onTouchEnd, {passive: !0}),
    t[a]('pointerout', i.onTouchEnd, {passive: !0}),
    t[a]('pointerleave', i.onTouchEnd, {passive: !0}),
    t[a]('contextmenu', i.onTouchEnd, {passive: !0}),
    (s.preventClicks || s.preventClicksPropagation) && n[a]('click', i.onClick, !0),
    s.cssMode && r[a]('scroll', i.onScroll),
    s.updateOnWindowResize
      ? i[c](o.ios || o.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', ue, !0)
      : i[c]('observerUpdate', ue, !0),
    n[a]('load', i.onLoad, {capture: !0});
};
function It() {
  const i = this,
    {params: e} = i;
  (i.onTouchStart = bt.bind(i)),
    (i.onTouchMove = xt.bind(i)),
    (i.onTouchEnd = Et.bind(i)),
    (i.onDocumentTouchStart = Lt.bind(i)),
    e.cssMode && (i.onScroll = Mt.bind(i)),
    (i.onClick = Ct.bind(i)),
    (i.onLoad = Pt.bind(i)),
    be(i, 'on');
}
function Ot() {
  be(this, 'off');
}
var At = {attachEvents: It, detachEvents: Ot};
const pe = (i, e) => i.grid && e.grid && e.grid.rows > 1;
function zt() {
  const i = this,
    {realIndex: e, initialized: t, params: s, el: n} = i,
    r = s.breakpoints;
  if (!r || (r && Object.keys(r).length === 0)) return;
  const o = i.getBreakpoint(r, i.params.breakpointsBase, i.el);
  if (!o || i.currentBreakpoint === o) return;
  const a = (o in r ? r[o] : void 0) || i.originalParams,
    c = pe(i, s),
    f = pe(i, a),
    u = s.enabled;
  c && !f
    ? (n.classList.remove(`${s.containerModifierClass}grid`, `${s.containerModifierClass}grid-column`),
      i.emitContainerClasses())
    : !c &&
      f &&
      (n.classList.add(`${s.containerModifierClass}grid`),
      ((a.grid.fill && a.grid.fill === 'column') || (!a.grid.fill && s.grid.fill === 'column')) &&
        n.classList.add(`${s.containerModifierClass}grid-column`),
      i.emitContainerClasses()),
    ['navigation', 'pagination', 'scrollbar'].forEach((d) => {
      if (typeof a[d] > 'u') return;
      const p = s[d] && s[d].enabled,
        g = a[d] && a[d].enabled;
      p && !g && i[d].disable(), !p && g && i[d].enable();
    });
  const h = a.direction && a.direction !== s.direction,
    m = s.loop && (a.slidesPerView !== s.slidesPerView || h),
    v = s.loop;
  h && t && i.changeDirection(), k(i.params, a);
  const y = i.params.enabled,
    M = i.params.loop;
  Object.assign(i, {
    allowTouchMove: i.params.allowTouchMove,
    allowSlideNext: i.params.allowSlideNext,
    allowSlidePrev: i.params.allowSlidePrev,
  }),
    u && !y ? i.disable() : !u && y && i.enable(),
    (i.currentBreakpoint = o),
    i.emit('_beforeBreakpoint', a),
    t &&
      (m
        ? (i.loopDestroy(), i.loopCreate(e), i.updateSlides())
        : !v && M
          ? (i.loopCreate(e), i.updateSlides())
          : v && !M && i.loopDestroy()),
    i.emit('breakpoint', a);
}
function Dt(i, e, t) {
  if ((e === void 0 && (e = 'window'), !i || (e === 'container' && !t))) return;
  let s = !1;
  const n = G(),
    r = e === 'window' ? n.innerHeight : t.clientHeight,
    o = Object.keys(i).map((l) => {
      if (typeof l == 'string' && l.indexOf('@') === 0) {
        const a = parseFloat(l.substr(1));
        return {value: r * a, point: l};
      }
      return {value: l, point: l};
    });
  o.sort((l, a) => parseInt(l.value, 10) - parseInt(a.value, 10));
  for (let l = 0; l < o.length; l += 1) {
    const {point: a, value: c} = o[l];
    e === 'window' ? n.matchMedia(`(min-width: ${c}px)`).matches && (s = a) : c <= t.clientWidth && (s = a);
  }
  return s || 'max';
}
var kt = {setBreakpoint: zt, getBreakpoint: Dt};
function Gt(i, e) {
  const t = [];
  return (
    i.forEach((s) => {
      typeof s == 'object'
        ? Object.keys(s).forEach((n) => {
            s[n] && t.push(e + n);
          })
        : typeof s == 'string' && t.push(e + s);
    }),
    t
  );
}
function $t() {
  const i = this,
    {classNames: e, params: t, rtl: s, el: n, device: r} = i,
    o = Gt(
      [
        'initialized',
        t.direction,
        {'free-mode': i.params.freeMode && t.freeMode.enabled},
        {autoheight: t.autoHeight},
        {rtl: s},
        {grid: t.grid && t.grid.rows > 1},
        {'grid-column': t.grid && t.grid.rows > 1 && t.grid.fill === 'column'},
        {android: r.android},
        {ios: r.ios},
        {'css-mode': t.cssMode},
        {centered: t.cssMode && t.centeredSlides},
        {'watch-progress': t.watchSlidesProgress},
      ],
      t.containerModifierClass
    );
  e.push(...o), n.classList.add(...e), i.emitContainerClasses();
}
function Vt() {
  const i = this,
    {el: e, classNames: t} = i;
  e.classList.remove(...t), i.emitContainerClasses();
}
var Bt = {addClasses: $t, removeClasses: Vt};
function Ft() {
  const i = this,
    {isLocked: e, params: t} = i,
    {slidesOffsetBefore: s} = t;
  if (s) {
    const n = i.slides.length - 1,
      r = i.slidesGrid[n] + i.slidesSizesGrid[n] + s * 2;
    i.isLocked = i.size > r;
  } else i.isLocked = i.snapGrid.length === 1;
  t.allowSlideNext === !0 && (i.allowSlideNext = !i.isLocked),
    t.allowSlidePrev === !0 && (i.allowSlidePrev = !i.isLocked),
    e && e !== i.isLocked && (i.isEnd = !1),
    e !== i.isLocked && i.emit(i.isLocked ? 'lock' : 'unlock');
}
var Nt = {checkOverflow: Ft},
  me = {
    init: !0,
    direction: 'horizontal',
    oneWayMovement: !1,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: 'swiper',
    enabled: !0,
    focusableElements: 'input, select, option, textarea, button, video, label',
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: 'slide',
    breakpoints: void 0,
    breakpointsBase: 'window',
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: 'swiper-',
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  };
function _t(i, e) {
  return function (s) {
    s === void 0 && (s = {});
    const n = Object.keys(s)[0],
      r = s[n];
    if (typeof r != 'object' || r === null) {
      k(e, s);
      return;
    }
    if (
      (i[n] === !0 && (i[n] = {enabled: !0}),
      n === 'navigation' && i[n] && i[n].enabled && !i[n].prevEl && !i[n].nextEl && (i[n].auto = !0),
      ['pagination', 'scrollbar'].indexOf(n) >= 0 && i[n] && i[n].enabled && !i[n].el && (i[n].auto = !0),
      !(n in i && 'enabled' in r))
    ) {
      k(e, s);
      return;
    }
    typeof i[n] == 'object' && !('enabled' in i[n]) && (i[n].enabled = !0), i[n] || (i[n] = {enabled: !1}), k(e, s);
  };
}
const re = {
    eventsEmitter: Be,
    update: Ue,
    translate: tt,
    transition: nt,
    slide: pt,
    loop: vt,
    grabCursor: yt,
    events: At,
    breakpoints: kt,
    checkOverflow: Nt,
    classes: Bt,
  },
  ne = {};
class V {
  constructor() {
    let e, t;
    for (var s = arguments.length, n = new Array(s), r = 0; r < s; r++) n[r] = arguments[r];
    n.length === 1 && n[0].constructor && Object.prototype.toString.call(n[0]).slice(8, -1) === 'Object'
      ? (t = n[0])
      : ([e, t] = n),
      t || (t = {}),
      (t = k({}, t)),
      e && !t.el && (t.el = e);
    const o = _();
    if (t.el && typeof t.el == 'string' && o.querySelectorAll(t.el).length > 1) {
      const f = [];
      return (
        o.querySelectorAll(t.el).forEach((u) => {
          const h = k({}, t, {el: u});
          f.push(new V(h));
        }),
        f
      );
    }
    const l = this;
    (l.__swiper__ = !0),
      (l.support = Se()),
      (l.device = ye({userAgent: t.userAgent})),
      (l.browser = Ge()),
      (l.eventsListeners = {}),
      (l.eventsAnyListeners = []),
      (l.modules = [...l.__modules__]),
      t.modules && Array.isArray(t.modules) && l.modules.push(...t.modules);
    const a = {};
    l.modules.forEach((f) => {
      f({
        params: t,
        swiper: l,
        extendParams: _t(t, a),
        on: l.on.bind(l),
        once: l.once.bind(l),
        off: l.off.bind(l),
        emit: l.emit.bind(l),
      });
    });
    const c = k({}, me, a);
    return (
      (l.params = k({}, c, ne, t)),
      (l.originalParams = k({}, l.params)),
      (l.passedParams = k({}, t)),
      l.params &&
        l.params.on &&
        Object.keys(l.params.on).forEach((f) => {
          l.on(f, l.params.on[f]);
        }),
      l.params && l.params.onAny && l.onAny(l.params.onAny),
      Object.assign(l, {
        enabled: l.params.enabled,
        el: e,
        classNames: [],
        slides: [],
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        isHorizontal() {
          return l.params.direction === 'horizontal';
        },
        isVertical() {
          return l.params.direction === 'vertical';
        },
        activeIndex: 0,
        realIndex: 0,
        isBeginning: !0,
        isEnd: !1,
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: !1,
        cssOverflowAdjustment() {
          return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
        },
        allowSlideNext: l.params.allowSlideNext,
        allowSlidePrev: l.params.allowSlidePrev,
        touchEventsData: {
          isTouched: void 0,
          isMoved: void 0,
          allowTouchCallbacks: void 0,
          touchStartTime: void 0,
          isScrolling: void 0,
          currentTranslate: void 0,
          startTranslate: void 0,
          allowThresholdMove: void 0,
          focusableElements: l.params.focusableElements,
          lastClickTime: 0,
          clickTimeout: void 0,
          velocities: [],
          allowMomentumBounce: void 0,
          startMoving: void 0,
          pointerId: null,
          touchId: null,
        },
        allowClick: !0,
        allowTouchMove: l.params.allowTouchMove,
        touches: {startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0},
        imagesToLoad: [],
        imagesLoaded: 0,
      }),
      l.emit('_swiper'),
      l.params.init && l.init(),
      l
    );
  }
  getDirectionLabel(e) {
    return this.isHorizontal()
      ? e
      : {
          width: 'height',
          'margin-top': 'margin-left',
          'margin-bottom ': 'margin-right',
          'margin-left': 'margin-top',
          'margin-right': 'margin-bottom',
          'padding-left': 'padding-top',
          'padding-right': 'padding-bottom',
          marginRight: 'marginBottom',
        }[e];
  }
  getSlideIndex(e) {
    const {slidesEl: t, params: s} = this,
      n = F(t, `.${s.slideClass}, swiper-slide`),
      r = Q(n[0]);
    return Q(e) - r;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.filter((t) => t.getAttribute('data-swiper-slide-index') * 1 === e)[0]);
  }
  recalcSlides() {
    const e = this,
      {slidesEl: t, params: s} = e;
    e.slides = F(t, `.${s.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit('enable'));
  }
  disable() {
    const e = this;
    e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit('disable'));
  }
  setProgress(e, t) {
    const s = this;
    e = Math.min(Math.max(e, 0), 1);
    const n = s.minTranslate(),
      o = (s.maxTranslate() - n) * e + n;
    s.translateTo(o, typeof t > 'u' ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = e.el.className
      .split(' ')
      .filter((s) => s.indexOf('swiper') === 0 || s.indexOf(e.params.containerModifierClass) === 0);
    e.emit('_containerClasses', t.join(' '));
  }
  getSlideClasses(e) {
    const t = this;
    return t.destroyed
      ? ''
      : e.className
          .split(' ')
          .filter((s) => s.indexOf('swiper-slide') === 0 || s.indexOf(t.params.slideClass) === 0)
          .join(' ');
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = [];
    e.slides.forEach((s) => {
      const n = e.getSlideClasses(s);
      t.push({slideEl: s, classNames: n}), e.emit('_slideClass', s, n);
    }),
      e.emit('_slideClasses', t);
  }
  slidesPerViewDynamic(e, t) {
    e === void 0 && (e = 'current'), t === void 0 && (t = !1);
    const s = this,
      {params: n, slides: r, slidesGrid: o, slidesSizesGrid: l, size: a, activeIndex: c} = s;
    let f = 1;
    if (typeof n.slidesPerView == 'number') return n.slidesPerView;
    if (n.centeredSlides) {
      let u = r[c] ? Math.ceil(r[c].swiperSlideSize) : 0,
        h;
      for (let m = c + 1; m < r.length; m += 1)
        r[m] && !h && ((u += Math.ceil(r[m].swiperSlideSize)), (f += 1), u > a && (h = !0));
      for (let m = c - 1; m >= 0; m -= 1) r[m] && !h && ((u += r[m].swiperSlideSize), (f += 1), u > a && (h = !0));
    } else if (e === 'current')
      for (let u = c + 1; u < r.length; u += 1) (t ? o[u] + l[u] - o[c] < a : o[u] - o[c] < a) && (f += 1);
    else for (let u = c - 1; u >= 0; u -= 1) o[c] - o[u] < a && (f += 1);
    return f;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {snapGrid: t, params: s} = e;
    s.breakpoints && e.setBreakpoint(),
      [...e.el.querySelectorAll('[loading="lazy"]')].forEach((o) => {
        o.complete && X(e, o);
      }),
      e.updateSize(),
      e.updateSlides(),
      e.updateProgress(),
      e.updateSlidesClasses();
    function n() {
      const o = e.rtlTranslate ? e.translate * -1 : e.translate,
        l = Math.min(Math.max(o, e.maxTranslate()), e.minTranslate());
      e.setTranslate(l), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let r;
    if (s.freeMode && s.freeMode.enabled && !s.cssMode) n(), s.autoHeight && e.updateAutoHeight();
    else {
      if ((s.slidesPerView === 'auto' || s.slidesPerView > 1) && e.isEnd && !s.centeredSlides) {
        const o = e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides;
        r = e.slideTo(o.length - 1, 0, !1, !0);
      } else r = e.slideTo(e.activeIndex, 0, !1, !0);
      r || n();
    }
    s.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit('update');
  }
  changeDirection(e, t) {
    t === void 0 && (t = !0);
    const s = this,
      n = s.params.direction;
    return (
      e || (e = n === 'horizontal' ? 'vertical' : 'horizontal'),
      e === n ||
        (e !== 'horizontal' && e !== 'vertical') ||
        (s.el.classList.remove(`${s.params.containerModifierClass}${n}`),
        s.el.classList.add(`${s.params.containerModifierClass}${e}`),
        s.emitContainerClasses(),
        (s.params.direction = e),
        s.slides.forEach((r) => {
          e === 'vertical' ? (r.style.width = '') : (r.style.height = '');
        }),
        s.emit('changeDirection'),
        t && s.update()),
      s
    );
  }
  changeLanguageDirection(e) {
    const t = this;
    (t.rtl && e === 'rtl') ||
      (!t.rtl && e === 'ltr') ||
      ((t.rtl = e === 'rtl'),
      (t.rtlTranslate = t.params.direction === 'horizontal' && t.rtl),
      t.rtl
        ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), (t.el.dir = 'rtl'))
        : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), (t.el.dir = 'ltr')),
      t.update());
  }
  mount(e) {
    const t = this;
    if (t.mounted) return !0;
    let s = e || t.params.el;
    if ((typeof s == 'string' && (s = document.querySelector(s)), !s)) return !1;
    (s.swiper = t),
      s.parentNode &&
        s.parentNode.host &&
        s.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() &&
        (t.isElement = !0);
    const n = () => `.${(t.params.wrapperClass || '').trim().split(' ').join('.')}`;
    let o = s && s.shadowRoot && s.shadowRoot.querySelector ? s.shadowRoot.querySelector(n()) : F(s, n())[0];
    return (
      !o &&
        t.params.createElements &&
        ((o = J('div', t.params.wrapperClass)),
        s.append(o),
        F(s, `.${t.params.slideClass}`).forEach((l) => {
          o.append(l);
        })),
      Object.assign(t, {
        el: s,
        wrapperEl: o,
        slidesEl: t.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : o,
        hostEl: t.isElement ? s.parentNode.host : s,
        mounted: !0,
        rtl: s.dir.toLowerCase() === 'rtl' || R(s, 'direction') === 'rtl',
        rtlTranslate:
          t.params.direction === 'horizontal' && (s.dir.toLowerCase() === 'rtl' || R(s, 'direction') === 'rtl'),
        wrongRTL: R(o, 'display') === '-webkit-box',
      }),
      !0
    );
  }
  init(e) {
    const t = this;
    if (t.initialized || t.mount(e) === !1) return t;
    t.emit('beforeInit'),
      t.params.breakpoints && t.setBreakpoint(),
      t.addClasses(),
      t.updateSize(),
      t.updateSlides(),
      t.params.watchOverflow && t.checkOverflow(),
      t.params.grabCursor && t.enabled && t.setGrabCursor(),
      t.params.loop && t.virtual && t.params.virtual.enabled
        ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0)
        : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
      t.params.loop && t.loopCreate(),
      t.attachEvents();
    const n = [...t.el.querySelectorAll('[loading="lazy"]')];
    return (
      t.isElement && n.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
      n.forEach((r) => {
        r.complete
          ? X(t, r)
          : r.addEventListener('load', (o) => {
              X(t, o.target);
            });
      }),
      oe(t),
      (t.initialized = !0),
      oe(t),
      t.emit('init'),
      t.emit('afterInit'),
      t
    );
  }
  destroy(e, t) {
    e === void 0 && (e = !0), t === void 0 && (t = !0);
    const s = this,
      {params: n, el: r, wrapperEl: o, slides: l} = s;
    return (
      typeof s.params > 'u' ||
        s.destroyed ||
        (s.emit('beforeDestroy'),
        (s.initialized = !1),
        s.detachEvents(),
        n.loop && s.loopDestroy(),
        t &&
          (s.removeClasses(),
          r.removeAttribute('style'),
          o.removeAttribute('style'),
          l &&
            l.length &&
            l.forEach((a) => {
              a.classList.remove(
                n.slideVisibleClass,
                n.slideFullyVisibleClass,
                n.slideActiveClass,
                n.slideNextClass,
                n.slidePrevClass
              ),
                a.removeAttribute('style'),
                a.removeAttribute('data-swiper-slide-index');
            })),
        s.emit('destroy'),
        Object.keys(s.eventsListeners).forEach((a) => {
          s.off(a);
        }),
        e !== !1 && ((s.el.swiper = null), Ce(s)),
        (s.destroyed = !0)),
      null
    );
  }
  static extendDefaults(e) {
    k(ne, e);
  }
  static get extendedDefaults() {
    return ne;
  }
  static get defaults() {
    return me;
  }
  static installModule(e) {
    V.prototype.__modules__ || (V.prototype.__modules__ = []);
    const t = V.prototype.__modules__;
    typeof e == 'function' && t.indexOf(e) < 0 && t.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((t) => V.installModule(t)), V) : (V.installModule(e), V);
  }
}
Object.keys(re).forEach((i) => {
  Object.keys(re[i]).forEach((e) => {
    V.prototype[e] = re[i][e];
  });
});
V.use([$e, Ve]);
function Rt(i, e, t, s) {
  return (
    i.params.createElements &&
      Object.keys(s).forEach((n) => {
        if (!t[n] && t.auto === !0) {
          let r = F(i.el, `.${s[n]}`)[0];
          r || ((r = J('div', s[n])), (r.className = s[n]), i.el.append(r)), (t[n] = r), (e[n] = r);
        }
      }),
    t
  );
}
function W(i) {
  return (
    i === void 0 && (i = ''),
    `.${i
      .trim()
      .replace(/([\.:!+\/])/g, '\\$1')
      .replace(/ /g, '.')}`
  );
}
function Ht(i) {
  let {swiper: e, extendParams: t, on: s, emit: n} = i;
  const r = 'swiper-pagination';
  t({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: 'bullets',
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (d) => d,
      formatFractionTotal: (d) => d,
      bulletClass: `${r}-bullet`,
      bulletActiveClass: `${r}-bullet-active`,
      modifierClass: `${r}-`,
      currentClass: `${r}-current`,
      totalClass: `${r}-total`,
      hiddenClass: `${r}-hidden`,
      progressbarFillClass: `${r}-progressbar-fill`,
      progressbarOppositeClass: `${r}-progressbar-opposite`,
      clickableClass: `${r}-clickable`,
      lockClass: `${r}-lock`,
      horizontalClass: `${r}-horizontal`,
      verticalClass: `${r}-vertical`,
      paginationDisabledClass: `${r}-disabled`,
    },
  }),
    (e.pagination = {el: null, bullets: []});
  let o,
    l = 0;
  function a() {
    return (
      !e.params.pagination.el || !e.pagination.el || (Array.isArray(e.pagination.el) && e.pagination.el.length === 0)
    );
  }
  function c(d, p) {
    const {bulletActiveClass: g} = e.params.pagination;
    d &&
      ((d = d[`${p === 'prev' ? 'previous' : 'next'}ElementSibling`]),
      d &&
        (d.classList.add(`${g}-${p}`),
        (d = d[`${p === 'prev' ? 'previous' : 'next'}ElementSibling`]),
        d && d.classList.add(`${g}-${p}-${p}`)));
  }
  function f(d) {
    const p = d.target.closest(W(e.params.pagination.bulletClass));
    if (!p) return;
    d.preventDefault();
    const g = Q(p) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === g) return;
      e.slideToLoop(g);
    } else e.slideTo(g);
  }
  function u() {
    const d = e.rtl,
      p = e.params.pagination;
    if (a()) return;
    let g = e.pagination.el;
    g = N(g);
    let S, b;
    const P = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
      D = e.params.loop ? Math.ceil(P / e.params.slidesPerGroup) : e.snapGrid.length;
    if (
      (e.params.loop
        ? ((b = e.previousRealIndex || 0),
          (S = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex))
        : typeof e.snapIndex < 'u'
          ? ((S = e.snapIndex), (b = e.previousSnapIndex))
          : ((b = e.previousIndex || 0), (S = e.activeIndex || 0)),
      p.type === 'bullets' && e.pagination.bullets && e.pagination.bullets.length > 0)
    ) {
      const C = e.pagination.bullets;
      let O, w, E;
      if (
        (p.dynamicBullets &&
          ((o = le(C[0], e.isHorizontal() ? 'width' : 'height')),
          g.forEach((x) => {
            x.style[e.isHorizontal() ? 'width' : 'height'] = `${o * (p.dynamicMainBullets + 4)}px`;
          }),
          p.dynamicMainBullets > 1 &&
            b !== void 0 &&
            ((l += S - (b || 0)), l > p.dynamicMainBullets - 1 ? (l = p.dynamicMainBullets - 1) : l < 0 && (l = 0)),
          (O = Math.max(S - l, 0)),
          (w = O + (Math.min(C.length, p.dynamicMainBullets) - 1)),
          (E = (w + O) / 2)),
        C.forEach((x) => {
          const T = [
            ...['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map((L) => `${p.bulletActiveClass}${L}`),
          ]
            .map((L) => (typeof L == 'string' && L.includes(' ') ? L.split(' ') : L))
            .flat();
          x.classList.remove(...T);
        }),
        g.length > 1)
      )
        C.forEach((x) => {
          const T = Q(x);
          T === S
            ? x.classList.add(...p.bulletActiveClass.split(' '))
            : e.isElement && x.setAttribute('part', 'bullet'),
            p.dynamicBullets &&
              (T >= O && T <= w && x.classList.add(...`${p.bulletActiveClass}-main`.split(' ')),
              T === O && c(x, 'prev'),
              T === w && c(x, 'next'));
        });
      else {
        const x = C[S];
        if (
          (x && x.classList.add(...p.bulletActiveClass.split(' ')),
          e.isElement &&
            C.forEach((T, L) => {
              T.setAttribute('part', L === S ? 'bullet-active' : 'bullet');
            }),
          p.dynamicBullets)
        ) {
          const T = C[O],
            L = C[w];
          for (let A = O; A <= w; A += 1) C[A] && C[A].classList.add(...`${p.bulletActiveClass}-main`.split(' '));
          c(T, 'prev'), c(L, 'next');
        }
      }
      if (p.dynamicBullets) {
        const x = Math.min(C.length, p.dynamicMainBullets + 4),
          T = (o * x - o) / 2 - E * o,
          L = d ? 'right' : 'left';
        C.forEach((A) => {
          A.style[e.isHorizontal() ? L : 'top'] = `${T}px`;
        });
      }
    }
    g.forEach((C, O) => {
      if (
        (p.type === 'fraction' &&
          (C.querySelectorAll(W(p.currentClass)).forEach((w) => {
            w.textContent = p.formatFractionCurrent(S + 1);
          }),
          C.querySelectorAll(W(p.totalClass)).forEach((w) => {
            w.textContent = p.formatFractionTotal(D);
          })),
        p.type === 'progressbar')
      ) {
        let w;
        p.progressbarOpposite
          ? (w = e.isHorizontal() ? 'vertical' : 'horizontal')
          : (w = e.isHorizontal() ? 'horizontal' : 'vertical');
        const E = (S + 1) / D;
        let x = 1,
          T = 1;
        w === 'horizontal' ? (x = E) : (T = E),
          C.querySelectorAll(W(p.progressbarFillClass)).forEach((L) => {
            (L.style.transform = `translate3d(0,0,0) scaleX(${x}) scaleY(${T})`),
              (L.style.transitionDuration = `${e.params.speed}ms`);
          });
      }
      p.type === 'custom' && p.renderCustom
        ? ((C.innerHTML = p.renderCustom(e, S + 1, D)), O === 0 && n('paginationRender', C))
        : (O === 0 && n('paginationRender', C), n('paginationUpdate', C)),
        e.params.watchOverflow && e.enabled && C.classList[e.isLocked ? 'add' : 'remove'](p.lockClass);
    });
  }
  function h() {
    const d = e.params.pagination;
    if (a()) return;
    const p =
      e.virtual && e.params.virtual.enabled
        ? e.virtual.slides.length
        : e.grid && e.params.grid.rows > 1
          ? e.slides.length / Math.ceil(e.params.grid.rows)
          : e.slides.length;
    let g = e.pagination.el;
    g = N(g);
    let S = '';
    if (d.type === 'bullets') {
      let b = e.params.loop ? Math.ceil(p / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && b > p && (b = p);
      for (let P = 0; P < b; P += 1)
        d.renderBullet
          ? (S += d.renderBullet.call(e, P, d.bulletClass))
          : (S += `<${d.bulletElement} ${e.isElement ? 'part="bullet"' : ''} class="${d.bulletClass}"></${d.bulletElement}>`);
    }
    d.type === 'fraction' &&
      (d.renderFraction
        ? (S = d.renderFraction.call(e, d.currentClass, d.totalClass))
        : (S = `<span class="${d.currentClass}"></span> / <span class="${d.totalClass}"></span>`)),
      d.type === 'progressbar' &&
        (d.renderProgressbar
          ? (S = d.renderProgressbar.call(e, d.progressbarFillClass))
          : (S = `<span class="${d.progressbarFillClass}"></span>`)),
      (e.pagination.bullets = []),
      g.forEach((b) => {
        d.type !== 'custom' && (b.innerHTML = S || ''),
          d.type === 'bullets' && e.pagination.bullets.push(...b.querySelectorAll(W(d.bulletClass)));
      }),
      d.type !== 'custom' && n('paginationRender', g[0]);
  }
  function m() {
    e.params.pagination = Rt(e, e.originalParams.pagination, e.params.pagination, {el: 'swiper-pagination'});
    const d = e.params.pagination;
    if (!d.el) return;
    let p;
    typeof d.el == 'string' && e.isElement && (p = e.el.querySelector(d.el)),
      !p && typeof d.el == 'string' && (p = [...document.querySelectorAll(d.el)]),
      p || (p = d.el),
      !(!p || p.length === 0) &&
        (e.params.uniqueNavElements &&
          typeof d.el == 'string' &&
          Array.isArray(p) &&
          p.length > 1 &&
          ((p = [...e.el.querySelectorAll(d.el)]),
          p.length > 1 && (p = p.filter((g) => we(g, '.swiper')[0] === e.el)[0])),
        Array.isArray(p) && p.length === 1 && (p = p[0]),
        Object.assign(e.pagination, {el: p}),
        (p = N(p)),
        p.forEach((g) => {
          d.type === 'bullets' && d.clickable && g.classList.add(...(d.clickableClass || '').split(' ')),
            g.classList.add(d.modifierClass + d.type),
            g.classList.add(e.isHorizontal() ? d.horizontalClass : d.verticalClass),
            d.type === 'bullets' &&
              d.dynamicBullets &&
              (g.classList.add(`${d.modifierClass}${d.type}-dynamic`),
              (l = 0),
              d.dynamicMainBullets < 1 && (d.dynamicMainBullets = 1)),
            d.type === 'progressbar' && d.progressbarOpposite && g.classList.add(d.progressbarOppositeClass),
            d.clickable && g.addEventListener('click', f),
            e.enabled || g.classList.add(d.lockClass);
        }));
  }
  function v() {
    const d = e.params.pagination;
    if (a()) return;
    let p = e.pagination.el;
    p &&
      ((p = N(p)),
      p.forEach((g) => {
        g.classList.remove(d.hiddenClass),
          g.classList.remove(d.modifierClass + d.type),
          g.classList.remove(e.isHorizontal() ? d.horizontalClass : d.verticalClass),
          d.clickable &&
            (g.classList.remove(...(d.clickableClass || '').split(' ')), g.removeEventListener('click', f));
      })),
      e.pagination.bullets &&
        e.pagination.bullets.forEach((g) => g.classList.remove(...d.bulletActiveClass.split(' ')));
  }
  s('changeDirection', () => {
    if (!e.pagination || !e.pagination.el) return;
    const d = e.params.pagination;
    let {el: p} = e.pagination;
    (p = N(p)),
      p.forEach((g) => {
        g.classList.remove(d.horizontalClass, d.verticalClass),
          g.classList.add(e.isHorizontal() ? d.horizontalClass : d.verticalClass);
      });
  }),
    s('init', () => {
      e.params.pagination.enabled === !1 ? M() : (m(), h(), u());
    }),
    s('activeIndexChange', () => {
      typeof e.snapIndex > 'u' && u();
    }),
    s('snapIndexChange', () => {
      u();
    }),
    s('snapGridLengthChange', () => {
      h(), u();
    }),
    s('destroy', () => {
      v();
    }),
    s('enable disable', () => {
      let {el: d} = e.pagination;
      d && ((d = N(d)), d.forEach((p) => p.classList[e.enabled ? 'remove' : 'add'](e.params.pagination.lockClass)));
    }),
    s('lock unlock', () => {
      u();
    }),
    s('click', (d, p) => {
      const g = p.target,
        S = N(e.pagination.el);
      if (
        e.params.pagination.el &&
        e.params.pagination.hideOnClick &&
        S &&
        S.length > 0 &&
        !g.classList.contains(e.params.pagination.bulletClass)
      ) {
        if (
          e.navigation &&
          ((e.navigation.nextEl && g === e.navigation.nextEl) || (e.navigation.prevEl && g === e.navigation.prevEl))
        )
          return;
        const b = S[0].classList.contains(e.params.pagination.hiddenClass);
        n(b === !0 ? 'paginationShow' : 'paginationHide'),
          S.forEach((P) => P.classList.toggle(e.params.pagination.hiddenClass));
      }
    });
  const y = () => {
      e.el.classList.remove(e.params.pagination.paginationDisabledClass);
      let {el: d} = e.pagination;
      d && ((d = N(d)), d.forEach((p) => p.classList.remove(e.params.pagination.paginationDisabledClass))),
        m(),
        h(),
        u();
    },
    M = () => {
      e.el.classList.add(e.params.pagination.paginationDisabledClass);
      let {el: d} = e.pagination;
      d && ((d = N(d)), d.forEach((p) => p.classList.add(e.params.pagination.paginationDisabledClass))), v();
    };
  Object.assign(e.pagination, {enable: y, disable: M, render: h, update: u, init: m, destroy: v});
}
function Wt(i) {
  let {swiper: e, extendParams: t, on: s, emit: n, params: r} = i;
  (e.autoplay = {running: !1, paused: !1, timeLeft: 0}),
    t({
      autoplay: {
        enabled: !1,
        delay: 3e3,
        waitForTransition: !0,
        disableOnInteraction: !1,
        stopOnLastSlide: !1,
        reverseDirection: !1,
        pauseOnMouseEnter: !1,
      },
    });
  let o,
    l,
    a = r && r.autoplay ? r.autoplay.delay : 3e3,
    c = r && r.autoplay ? r.autoplay.delay : 3e3,
    f,
    u = new Date().getTime(),
    h,
    m,
    v,
    y,
    M,
    d,
    p;
  function g(I) {
    !e ||
      e.destroyed ||
      !e.wrapperEl ||
      (I.target === e.wrapperEl && (e.wrapperEl.removeEventListener('transitionend', g), !p && w()));
  }
  const S = () => {
      if (e.destroyed || !e.autoplay.running) return;
      e.autoplay.paused ? (h = !0) : h && ((c = f), (h = !1));
      const I = e.autoplay.paused ? f : u + c - new Date().getTime();
      (e.autoplay.timeLeft = I),
        n('autoplayTimeLeft', I, I / a),
        (l = requestAnimationFrame(() => {
          S();
        }));
    },
    b = () => {
      let I;
      return (
        e.virtual && e.params.virtual.enabled
          ? (I = e.slides.filter((z) => z.classList.contains('swiper-slide-active'))[0])
          : (I = e.slides[e.activeIndex]),
        I ? parseInt(I.getAttribute('data-swiper-autoplay'), 10) : void 0
      );
    },
    P = (I) => {
      if (e.destroyed || !e.autoplay.running) return;
      cancelAnimationFrame(l), S();
      let $ = typeof I > 'u' ? e.params.autoplay.delay : I;
      (a = e.params.autoplay.delay), (c = e.params.autoplay.delay);
      const z = b();
      !Number.isNaN(z) && z > 0 && typeof I > 'u' && (($ = z), (a = z), (c = z)), (f = $);
      const H = e.params.speed,
        q = () => {
          !e ||
            e.destroyed ||
            (e.params.autoplay.reverseDirection
              ? !e.isBeginning || e.params.loop || e.params.rewind
                ? (e.slidePrev(H, !0, !0), n('autoplay'))
                : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, H, !0, !0), n('autoplay'))
              : !e.isEnd || e.params.loop || e.params.rewind
                ? (e.slideNext(H, !0, !0), n('autoplay'))
                : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, H, !0, !0), n('autoplay')),
            e.params.cssMode &&
              ((u = new Date().getTime()),
              requestAnimationFrame(() => {
                P();
              })));
        };
      return (
        $ > 0
          ? (clearTimeout(o),
            (o = setTimeout(() => {
              q();
            }, $)))
          : requestAnimationFrame(() => {
              q();
            }),
        $
      );
    },
    D = () => {
      (u = new Date().getTime()), (e.autoplay.running = !0), P(), n('autoplayStart');
    },
    C = () => {
      (e.autoplay.running = !1), clearTimeout(o), cancelAnimationFrame(l), n('autoplayStop');
    },
    O = (I, $) => {
      if (e.destroyed || !e.autoplay.running) return;
      clearTimeout(o), I || (d = !0);
      const z = () => {
        n('autoplayPause'),
          e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener('transitionend', g) : w();
      };
      if (((e.autoplay.paused = !0), $)) {
        M && (f = e.params.autoplay.delay), (M = !1), z();
        return;
      }
      (f = (f || e.params.autoplay.delay) - (new Date().getTime() - u)),
        !(e.isEnd && f < 0 && !e.params.loop) && (f < 0 && (f = 0), z());
    },
    w = () => {
      (e.isEnd && f < 0 && !e.params.loop) ||
        e.destroyed ||
        !e.autoplay.running ||
        ((u = new Date().getTime()), d ? ((d = !1), P(f)) : P(), (e.autoplay.paused = !1), n('autoplayResume'));
    },
    E = () => {
      if (e.destroyed || !e.autoplay.running) return;
      const I = _();
      I.visibilityState === 'hidden' && ((d = !0), O(!0)), I.visibilityState === 'visible' && w();
    },
    x = (I) => {
      I.pointerType === 'mouse' && ((d = !0), (p = !0), !(e.animating || e.autoplay.paused) && O(!0));
    },
    T = (I) => {
      I.pointerType === 'mouse' && ((p = !1), e.autoplay.paused && w());
    },
    L = () => {
      e.params.autoplay.pauseOnMouseEnter &&
        (e.el.addEventListener('pointerenter', x), e.el.addEventListener('pointerleave', T));
    },
    A = () => {
      e.el.removeEventListener('pointerenter', x), e.el.removeEventListener('pointerleave', T);
    },
    B = () => {
      _().addEventListener('visibilitychange', E);
    },
    Z = () => {
      _().removeEventListener('visibilitychange', E);
    };
  s('init', () => {
    e.params.autoplay.enabled && (L(), B(), D());
  }),
    s('destroy', () => {
      A(), Z(), e.autoplay.running && C();
    }),
    s('_freeModeStaticRelease', () => {
      (v || d) && w();
    }),
    s('_freeModeNoMomentumRelease', () => {
      e.params.autoplay.disableOnInteraction ? C() : O(!0, !0);
    }),
    s('beforeTransitionStart', (I, $, z) => {
      e.destroyed || !e.autoplay.running || (z || !e.params.autoplay.disableOnInteraction ? O(!0, !0) : C());
    }),
    s('sliderFirstMove', () => {
      if (!(e.destroyed || !e.autoplay.running)) {
        if (e.params.autoplay.disableOnInteraction) {
          C();
          return;
        }
        (m = !0),
          (v = !1),
          (d = !1),
          (y = setTimeout(() => {
            (d = !0), (v = !0), O(!0);
          }, 200));
      }
    }),
    s('touchEnd', () => {
      if (!(e.destroyed || !e.autoplay.running || !m)) {
        if ((clearTimeout(y), clearTimeout(o), e.params.autoplay.disableOnInteraction)) {
          (v = !1), (m = !1);
          return;
        }
        v && e.params.cssMode && w(), (v = !1), (m = !1);
      }
    }),
    s('slideChange', () => {
      e.destroyed || !e.autoplay.running || (M = !0);
    }),
    Object.assign(e.autoplay, {start: D, stop: C, pause: O, resume: w});
}
function qt(i) {
  const {
    effect: e,
    swiper: t,
    on: s,
    setTranslate: n,
    setTransition: r,
    overwriteParams: o,
    perspective: l,
    recreateShadows: a,
    getEffectParams: c,
  } = i;
  s('beforeInit', () => {
    if (t.params.effect !== e) return;
    t.classNames.push(`${t.params.containerModifierClass}${e}`),
      l && l() && t.classNames.push(`${t.params.containerModifierClass}3d`);
    const u = o ? o() : {};
    Object.assign(t.params, u), Object.assign(t.originalParams, u);
  }),
    s('setTranslate', () => {
      t.params.effect === e && n();
    }),
    s('setTransition', (u, h) => {
      t.params.effect === e && r(h);
    }),
    s('transitionEnd', () => {
      if (t.params.effect === e && a) {
        if (!c || !c().slideShadows) return;
        t.slides.forEach((u) => {
          u.querySelectorAll(
            '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
          ).forEach((h) => h.remove());
        }),
          a();
      }
    });
  let f;
  s('virtualUpdate', () => {
    t.params.effect === e &&
      (t.slides.length || (f = !0),
      requestAnimationFrame(() => {
        f && t.slides && t.slides.length && (n(), (f = !1));
      }));
  });
}
function jt(i, e) {
  const t = ve(e);
  return t !== e && ((t.style.backfaceVisibility = 'hidden'), (t.style['-webkit-backface-visibility'] = 'hidden')), t;
}
function Yt(i) {
  let {swiper: e, duration: t, transformElements: s, allSlides: n} = i;
  const {activeIndex: r} = e,
    o = (l) =>
      l.parentElement ? l.parentElement : e.slides.filter((c) => c.shadowRoot && c.shadowRoot === l.parentNode)[0];
  if (e.params.virtualTranslate && t !== 0) {
    let l = !1,
      a;
    n
      ? (a = s)
      : (a = s.filter((c) => {
          const f = c.classList.contains('swiper-slide-transform') ? o(c) : c;
          return e.getSlideIndex(f) === r;
        })),
      a.forEach((c) => {
        Ae(c, () => {
          if (l || !e || e.destroyed) return;
          (l = !0), (e.animating = !1);
          const f = new window.CustomEvent('transitionend', {bubbles: !0, cancelable: !0});
          e.wrapperEl.dispatchEvent(f);
        });
      });
  }
}
function Xt(i) {
  let {swiper: e, extendParams: t, on: s} = i;
  t({fadeEffect: {crossFade: !1}}),
    qt({
      effect: 'fade',
      swiper: e,
      on: s,
      setTranslate: () => {
        const {slides: o} = e,
          l = e.params.fadeEffect;
        for (let a = 0; a < o.length; a += 1) {
          const c = e.slides[a];
          let u = -c.swiperSlideOffset;
          e.params.virtualTranslate || (u -= e.translate);
          let h = 0;
          e.isHorizontal() || ((h = u), (u = 0));
          const m = e.params.fadeEffect.crossFade
              ? Math.max(1 - Math.abs(c.progress), 0)
              : 1 + Math.min(Math.max(c.progress, -1), 0),
            v = jt(l, c);
          (v.style.opacity = m), (v.style.transform = `translate3d(${u}px, ${h}px, 0px)`);
        }
      },
      setTransition: (o) => {
        const l = e.slides.map((a) => ve(a));
        l.forEach((a) => {
          a.style.transitionDuration = `${o}ms`;
        }),
          Yt({swiper: e, duration: o, transformElements: l, allSlides: !0});
      },
      overwriteParams: () => ({
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: !0,
        spaceBetween: 0,
        virtualTranslate: !e.params.cssMode,
      }),
    });
}
document.addEventListener('DOMContentLoaded', () => {
  const i = document.querySelector('[data-swiper-wrapper]'),
    e = i.dataset.swiperDelay;
  i &&
    new V('.hero-carousel-swiper', {
      modules: [Ht, Wt, Xt],
      speed: 500,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {crossFade: !0},
      autoplay: {delay: e},
      pagination: {el: '.swiper-pagination', clickable: !0},
    });
});
